import {
  HiOutlineHome,
  HiOutlineMail,
  // HiOutlineUsers
} from "react-icons/hi";
import {
  TbCalendar,
  TbChartHistogram,
  // TbFile,
  // TbFileInvoice,
  TbLockAccess,
  TbUsers,
} from "react-icons/tb";
import { FaRegCalendarAlt, FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import {
  RiFileList3Line,
  RiHeartLine,
  // RiImageLine,
  RiLockPasswordLine,
  // RiMedicineBottleLine,
  RiMoneyDollarCircleLine,
  // RiStethoscopeLine,
  // RiUserHeartLine,
  RiUserLine,
} from "react-icons/ri";
import { GiChemicalDrop } from "react-icons/gi";
import {
  MdListAlt,
  MdOutlineAttachMoney,
  // MdOutlineCampaign,
  // MdOutlineInventory2,
  MdOutlinePanoramaPhotosphereSelect,
  MdOutlineTextsms,
} from "react-icons/md";
import { AiOutlineSetting } from "react-icons/ai";
import { BiCalendar, BiUserPlus } from "react-icons/bi";
import { IoNotifications } from "react-icons/io5";

export const MenuDatas = [
  {
    title: "Inicio",
    path: "/",
    icon: HiOutlineHome,
  },
  {
    title: "Pacientes",
    path: "/patients",
    icon: TbUsers,
  },
  // {
  //   title: 'Receptions',
  //   path: '/receptions',
  //   icon: HiOutlineUsers,
  // },
  // {
  //   title: 'Doctors',
  //   path: '/doctors',
  //   icon: RiUserHeartLine,
  // },

  {
    title: "Agenda",
    path: "/appointments",
    icon: FaRegCalendarAlt,
  },
  {
    title: "Análisis y Laboratorios",
    path: "/laboratories",
    icon: GiChemicalDrop,
  },
  {
    title: "Pagos",
    path: "/payments",
    icon: MdListAlt,
  },
  // {
  //   title: 'Invoices',
  //   path: '/invoices',
  //   icon: TbFileInvoice,
  // },
  // {
  //   title: 'Services',
  //   path: '/services',
  //   icon: MdOutlineInventory2,
  // },
  // {
  //   title: 'Medicine',
  //   path: '/medicine',
  //   icon: RiMedicineBottleLine,
  // },
  {
    title: "Notificaciones",
    path: "/notifications",
    icon: IoNotifications,
  },
  {
    title: "Configuracion",
    path: "/settings",
    icon: AiOutlineSetting,
  },
];
export const memberData = [
  {
    id: 1,
    title: "Hugo Lloris",
    image: "/images/user1.png",
    admin: false,
    email: "hugolloris@gmail.com",
    phone: "+1 234 567 890",
    age: 25,
    gender: "Male",
    blood: "A+",
    totalAppointments: 5,
    date: "20 Aug 2021",
  },
  {
    id: 2,
    title: "Mauris auctor",
    image: "/images/user2.png",
    admin: false,
    email: "maurisauctor@gmail.com",
    phone: "+1 456 789 123",
    age: 34,
    gender: "Female",
    blood: "B+",
    totalAppointments: 3,
    date: "22 Nov 2023",
  },
  {
    id: 3,
    title: "Michael Owen",
    image: "/images/user3.png",
    admin: false,
    phone: "+1 890 123 456",
    email: "michaelowen@gmail.com",
    age: 45,
    gender: "Male",
    blood: "O+",
    totalAppointments: 26,
    date: "12 Jan 2020",
  },
  {
    id: 4,
    title: "Amina Smith",
    image: "/images/user4.png",
    admin: true,
    phone: "+1 908 765 432",
    email: "aminasmith@gmail.com",
    age: 28,
    gender: "Female",
    blood: "AB+",
    totalAppointments: 17,
    date: "07 Feb 2001",
  },
  {
    id: 5,
    title: "Minahil Khan",
    image: "/images/user5.png",
    admin: false,
    phone: "+1 890 123 456",
    email: "minahilkhan@gmail.com",
    age: 35,
    gender: "Female",
    blood: "A+",
    totalAppointments: 9,
    date: "30 Dec 2019",
  },
  {
    id: 6,
    title: "Alex Morgan",
    image: "/images/user6.png",
    admin: false,
    phone: "+1 908 765 432",
    email: "alexmorgan@gmail.com",
    age: 29,
    gender: "Male",
    blood: "B+",
    totalAppointments: 34,
    date: "12 Jan 2020",
  },
  {
    id: 7,
    title: "John Doe",
    image: "/images/user7.png",
    admin: false,
    phone: "+1 234 567 890",
    email: "johndoe@gmail.com",
    age: 32,
    gender: "Male",
    blood: "O-",
    totalAppointments: 12,
    date: "18 Mar 2023",
  },
  {
    id: 8,
    title: "David Beckham",
    image: "/images/user8.png",
    admin: false,
    phone: "+1 456 789 123",
    email: "davidbackham@gmail.com",
    age: 27,
    gender: "Female",
    blood: "AB+",
    totalAppointments: 70,
    date: "01 June 2018",
  },
];

export const sortsDatas = {
  status: [
    {
      id: 1,
      name: "Status...",
    },
    {
      id: 2,
      name: "Pendiente",
    },
    {
      id: 3,
      name: "Aprobado",
    },
    {
      id: 4,
      name: "Cancelado",
    },
  ],
  method: [
    {
      id: 1,
      name: "Payment method",
    },
    {
      id: 2,
      name: "Cash",
    },
    {
      id: 3,
      name: "NHCF Insurance",
    },
    {
      id: 4,
      name: "Britam Insurance",
    },
  ],
  currency: [
    {
      id: 1,
      name: "Select Currency",
    },
    {
      id: 2,
      name: "USD (US Dollar)",
    },
    {
      id: 3,
      name: "EUR (Euro)",
    },
    {
      id: 4,
      name: "TSH (Tanzanian Shilling)",
    },
  ],
  instractions: [
    {
      id: 0,
      name: "Ninguno",
    },
    {
      id: 1,
      name: "Cada 8 horas",
    },
    {
      id: 2,
      name: "Despues de cada comida",
    },
    {
      id: 3,
      name: "Antes de cada comida",
    },
  ],
  measure: [
    {
      id: 1,
      name: "Select Measure",
    },
    {
      id: 2,
      name: "mg",
    },
    {
      id: 3,
      name: "ml",
    },
    {
      id: 4,
      name: "gm",
    },
    {
      id: 5,
      name: "kg",
    },
    {
      id: 6,
      name: "lb",
    },
    {
      id: 7,
      name: "tbsp",
    },
    {
      id: 8,
      name: "tablet",
    },
    {
      id: 9,
      name: "capsule",
    },
  ],
  stocks: [
    {
      id: 1,
      name: "All",
    },
    {
      id: 2,
      name: "Available",
    },
    {
      id: 3,
      name: "Out of Stock",
    },
  ],
  service: [
    {
      id: 1,
      name: "All",
    },
    {
      id: 2,
      name: "Enabled",
    },
    {
      id: 3,
      name: "Disabled",
    },
  ],
  title: [
    {
      id: 1,
      name: "Dr.",
    },
    {
      id: 2,
      name: "Mr.",
    },
    {
      id: 3,
      name: "Mrs.",
    },
    {
      id: 4,
      name: "Ms.",
    },
  ],
  filterPatient: [
    {
      id: 1,
      name: "Ordenar por...",
    },
    {
      id: 2,
      name: "Pacientes nuevos",
    },
    {
      id: 3,
      name: "Pacientes antiguos",
    },
  ],
  genderFilter: [
    {
      id: 1,
      name: "Femenino",
    },
    {
      id: 2,
      name: "Masculino",
    },
    {
      id: 3,
      name: "Otro",
    },
  ],
  maritalStatus: [
    {
      id: 1,
      name: "Soltero/a",
    },
    {
      id: 2,
      name: "Casado/a",
    },
    {
      id: 3,
      name: "Divorciado/a",
    },
    {
      id: 4,
      name: "Viudo/a",
    },
  ],
  bloodTypeFilter: [
    {
      id: 1,
      name: "Ninguno",
    },
    {
      id: 2,
      name: "A+",
    },
    {
      id: 3,
      name: "A-",
    },
    {
      id: 4,
      name: "B+",
    },
    {
      id: 5,
      name: "B-",
    },
    {
      id: 6,
      name: "AB+",
    },
    {
      id: 7,
      name: "AB-",
    },
    {
      id: 8,
      name: "O+",
    },
    {
      id: 9,
      name: "O-",
    },
  ],
  dosage: [
    {
      id: 1,
      name: "Mañana (M)",
      value: "morning",
    },
    {
      id: 2,
      name: "Tarde (T)",
      value: "afternoon",
    },
    {
      id: 3,
      name: "Noche (N)",
      value: "evening",
    },
  ],
};

export const campaignData = [
  {
    id: 1,
    title: "Offer on Dental Checkup",
    date: "3 days ago",
    type: "email",
    sendTo: "All Patients",
    action: {
      subject: "Delight patients with a free dental checkup",
      message:
        "Dear Patient, We are delighted to offer you a free dental checkup. Please visit our clinic to avail this offer. Thank you. and have a nice day. and welcome to our clinic.",
      subHeader: "Offer on Dental Checkup",
      header: "How to avail this offer?",
      footer: "This offer is valid till 30th June, 2021",
    },
  },
  {
    id: 2,
    title: "Britam Insurance Offer",
    date: "8 days ago",
    type: "whatsapp",
    sendTo: "Britam Patients",
    action: {
      message:
        "Hellow Patient, are you looking for a free dental checkup? We are delighted to offer you a free dental checkup. Please visit our clinic to avail this offer. Thank you.",
    },
  },
  {
    id: 3,
    title: "NHCF Insurance Offer",
    date: "10 days ago",
    type: "sms",
    sendTo: "NHCF Patients",
    action: {
      message:
        "Hola, Delight patient with NHCF Insurance, We are delighted to offer you a free dental checkup. Please visit our clinic to avail this offer. Thank you.",
    },
  },
  {
    id: 4,
    title: "Cash patients offer",
    date: "15 days ago",
    type: "sms",
    sendTo: "Cash Patients",
    action: {
      message:
        "Delight Patient, now get 50% off on dental checkup. Please visit our clinic to avail this offer. Thank you. and have a nice day. and welcome to our clinic.",
    },
  },
  {
    id: 5,
    title: "Braces Offer",
    date: "12 days ago",
    type: "email",
    sendTo: "Britam Patients",
    action: {
      subject: "Delight patients with a free dental checkup",
      message:
        "Dear Patient, Britam Insurance is delighted to offer you a free dental checkup. Please visit our clinic to avail this offer. Thank you. and have a nice day. and welcome to our clinic.",
      subHeader: "Braces Offer for Britam Patients",
      header: "Now get braces at 50% off",
      footer: "This offer is valid till 30th June, 2021",
    },
  },
  {
    id: 6,
    title: "Teeth Whitening Offer",
    date: "20 days ago",
    type: "whatsapp",
    sendTo: "All Patients",
    action: {
      message:
        "Hola, Delight patient with Teeth Whitening Offer, We are delighted to offer you a free dental checkup. Please visit our clinic to avail this offer. Thank you.",
    },
  },
];
export const servicesData = [
  {
    id: 2,
    name: "Consulta",
    price: 40000,
    date: "23 June, 2021",
    status: true,
  },
  {
    id: 3,
    name: "Reconsulta",
    price: 20000,
    date: "12 Jan, 2022",
    status: true,
  },
  {
    id: 4,
    name: "Crioterapia",
    price: 50000,
    date: "11 April, 2023",
    status: false,
  },
  {
    id: 5,
    name: "Electrocirugía",
    price: 34000,
    date: "10 Agst, 2021",
    status: false,
  },
  {
    id: 6,
    name: "Limpieza facial profunda",
    price: 34000,
    date: "10 Agst, 2021",
    status: false,
  },
  {
    id: 7,
    name: "Microdermoabrasión",
    price: 34000,
    date: "10 Agst, 2021",
    status: false,
  },
  {
    id: 8,
    name: "Dermapen",
    price: 34000,
    date: "10 Agst, 2021",
    status: false,
  },
  {
    id: 9,
    name: "Infiltración con corticoide",
    price: 34000,
    date: "10 Agst, 2021",
    status: false,
  },
  {
    id: 10,
    name: "Resección con punch",
    price: 34000,
    date: "10 Agst, 2021",
    status: false,
  },
  {
    id: 11,
    name: "Biopsia",
    price: 34000,
    date: "10 Agst, 2021",
    status: false,
  },
  {
    id: 12,
    name: "Peeling",
    price: 34000,
    date: "10 Agst, 2021",
    status: false,
  },
];

export const invoicesData = [
  {
    id: 206719,
    to: memberData[5],
    total: 6070,
    createdDate: "12/06/2021",
    dueDate: "16/06/2021",
    items: [
      {
        id: 1,
        name: servicesData[0].name,
        price: 500,
        description:
          "Root Canal Treatment with X-Ray and Consultation is included in this package",
      },
      {
        id: 2,
        name: servicesData[0].name,
        price: 300,
        description: "Teeth Whitening Treatment",
      },
      {
        id: 3,
        name: servicesData[1].name,
        price: 260,
        description: "Dental Implants Treatment",
      },
      {
        id: 4,
        name: servicesData[2].name,
        price: 190000,
        description: "Dental Crowns Treatment",
      },
      {
        id: 5,
        name: servicesData[3].name,
        price: 15000,
        description: "Dental Bridges Treatment",
      },
    ],
  },
  {
    id: 198772,
    to: memberData[6],
    total: 5000,
    createdDate: "10/02/2023",
    dueDate: "14/02/2023",
    items: [
      {
        id: 1,
        name: servicesData[0].name,
        price: 190000,
        description: "Dental Crowns Treatment",
      },
      {
        id: 2,
        name: servicesData[2].name,
        price: 15000,
        description: "Dental Bridges Treatment",
      },
      {
        id: 3,
        name: servicesData[1].name,
        price: 20000,
        description: "Dentures Treatment",
      },
      {
        id: 4,
        name: servicesData[3].name,
        price: 190000,
        description: "Dental Crowns Treatment",
      },
    ],
  },
  {
    id: 456789,
    to: memberData[7],
    total: 10000,
    createdDate: "09/01/2023",
    dueDate: "13/01/2023",
    items: [
      {
        id: 1,
        name: servicesData[0].name,
        price: 5000,
        description: "Dental Veneers Treatment",
      },
      {
        id: 2,
        name: servicesData[1].name,
        price: 16000,
        description: "Dental Braces Treatment",
      },
      {
        id: 3,
        name: servicesData[2].name,
        price: 10000,
        description: "Dental Sealants Treatment",
      },
      {
        id: 4,
        name: servicesData[3].name,
        price: 20000,
        description: "Dentures Treatment",
      },
    ],
  },
  {
    id: 876543,
    to: memberData[4],
    total: 19000,
    createdDate: "08/01/2023",
    dueDate: "12/01/2023",
    items: [
      {
        id: 1,
        name: servicesData[0].name,
        price: 5000,
        description: "Dental Veneers Treatment",
      },
      {
        id: 2,
        name: servicesData[1].name,
        price: 16000,
        description: "Dental Braces Treatment",
      },
      {
        id: 3,
        name: servicesData[2].name,
        price: 10000,
        description: "Dental Sealants Treatment",
      },
      {
        id: 4,
        name: servicesData[3].name,
        price: 20000,
        description: "Dentures Treatment",
      },
      {
        id: 5,
        name: servicesData[3].name,
        price: 190000,
        description: "Dental Crowns Treatment",
      },
      {
        id: 6,
        name: servicesData[1].name,
        price: 15000,
        description: "Dental Bridges Treatment",
      },
    ],
  },
];

export const appointmentsData = [
  {
    id: 1,
    time: "+ 2 hrs",
    user: memberData[4],
    from: "10:00 AM",
    to: "12:00 PM",
    hours: 2,
    status: "Pending",
    doctor: memberData[0],
    date: "Jun 12, 2021",
  },
  {
    id: 2,
    time: "+ 1 hrs",
    user: memberData[5],
    from: "13:00 Pm",
    to: "18:00 PM",
    hours: 5,
    status: "Cancel",
    doctor: memberData[1],
    date: "Feb 24, 2021",
  },
  {
    id: 3,
    time: "- 2 hrs",
    user: memberData[6],
    from: "10:00 AM",
    to: "12:00 PM",
    hours: 2,
    status: "Approved",
    doctor: memberData[2],
    date: "Mar 12, 2023",
  },
  {
    id: 4,
    time: "- 3 hrs",
    user: memberData[7],
    from: "06:00 AM",
    to: "08:00 AM",
    hours: 3,
    status: "Pending",
    doctor: memberData[3],
    date: "Apr 06, 2023",
  },
  {
    id: 5,
    time: "- 4 hrs",
    user: memberData[3],
    from: "10:00 AM",
    to: "12:00 PM",
    hours: 7,
    status: "Approved",
    doctor: memberData[4],
    date: "May 18, 2023",
  },
];

export const transactionData = [
  {
    id: 1,
    user: memberData[0],
    date: "Mar 12, 2022",
    amount: 1000,
    status: "Paid",
    method: "Cash",
    doctor: memberData[3],
  },
  {
    id: 2,
    user: memberData[1],
    date: "Agus 12, 2023",
    amount: 2300,
    status: "Paid",
    method: "NHCF",
    doctor: memberData[4],
  },
  {
    id: 3,
    user: memberData[2],
    date: "Jan 06, 2024",
    amount: 1200,
    status: "Pending",
    method: "Britam",
    doctor: memberData[5],
  },
  {
    id: 4,
    user: memberData[3],
    date: "Feb 18, 2025",
    amount: 1400,
    status: "Cancel",
    method: "NHCF",
    doctor: memberData[6],
  },
  {
    id: 5,
    user: memberData[4],
    date: "Mar 12, 2026",
    amount: 1230,
    status: "Pending",
    method: "Cash",
    doctor: memberData[7],
  },
  {
    id: 6,
    user: memberData[5],
    date: "Apr 12, 2027",
    amount: 1000,
    status: "Paid",
    method: "NHCF",
    doctor: memberData[0],
  },
  {
    id: 7,
    user: memberData[6],
    date: "May 12, 2028",
    amount: 8900,
    status: "Cancel",
    method: "Britam",
    doctor: memberData[1],
  },
  {
    id: 8,
    user: memberData[7],
    date: "Jun 12, 2029",
    amount: 1000,
    status: "Pending",
    method: "Britam",
    doctor: memberData[2],
  },
];

export const dashboardCards = [
  {
    id: 1,
    title: "Pacientes en Total",
    icon: TbUsers,
    value: 160,
    // percent: 45.06,
    color: ["bg-subMain", "text-subMain", "#66B5A3"],
    datas: [9, 8, 5, 5, 9, 7, 7, 5, 10, 2, 9, 6],
  },
  {
    id: 2,
    title: "Citas",
    icon: TbCalendar,
    value: 130,
    // percent: 25.06,
    color: ["bg-yellow-500", "text-yellow-500", "#F9C851"],
    datas: [20, 50, 75, 15, 108, 97, 70, 41, 50, 20, 90, 60],
  },
  // {
  //   id: 3,
  //   title: 'Prescriptions',
  //   icon: TbFile,
  //   value: 4160,
  //   percent: 65.06,
  //   color: ['bg-green-500', 'text-green-500', '#34C759'],
  //   datas: [92, 80, 45, 15, 49, 77, 70, 51, 110, 20, 90, 60],
  // },
  {
    id: 4,
    title: "Total Pagos",
    icon: MdOutlineAttachMoney,
    value: 45900,
    // percent: 45.06,
    color: ["bg-red-500", "text-red-500", "#FF3B30"],
    datas: [200, 500, 750, 150, 1080, 970, 700, 410, 500, 200, 900, 600],
  },
];

export const notificationsData = [
  {
    id: 1,
    action: 1,
    user: memberData[0],
    time: "Hace 2 horas",
  },
  {
    id: 2,
    action: 2,
    user: memberData[1],
    time: "Hace 2 días",
  },
  {
    id: 3,
    action: 1,
    user: memberData[2],
    time: "Hace 3 días",
  },
  {
    id: 4,
    action: 2,
    user: memberData[3],
    time: "Hace 4 días",
  },
];

export const shareData = [
  {
    id: 1,
    icon: HiOutlineMail,
    title: "Email",
    description: "Send to patient email address",
  },
  {
    id: 2,
    icon: MdOutlineTextsms,
    title: "SMS",
    description: "Send to patient phone number",
  },
  {
    id: 3,
    icon: FaWhatsapp,
    title: "WhatsApp",
    description: "Send to patient WhatsApp account",
  },
  {
    id: 4,
    icon: FaTelegramPlane,
    title: "Telegram",
    description: "Send to patient Telegram account",
  },
];

export const medicineData = [
  {
    id: 1,
    name: "Paracetamol",
    measure: "Tablet",
    stock: 400,
    price: 1000,
    status: "Available",
    instraction: "After meal",
  },
  {
    id: 2,
    name: "Amoxicillin",
    measure: "Capsule",
    stock: 200,
    price: 2300,
    status: "Available",
    instraction: "After meal",
  },
  {
    id: 3,
    name: "Ibuprofen",
    measure: "mm",
    stock: 0,
    price: 5000,
    status: "Out of stock",
    instraction: "Before meal",
  },
  {
    id: 4,
    name: "Aspirin",
    measure: "cm",
    stock: 370,
    price: 3500,
    status: "Available",
    instraction: "After meal",
  },
  {
    id: 5,
    name: "Diazepam",
    measure: "gm",
    stock: 0,
    price: 12000,
    status: "Out of stock",
    instraction: "Before meal",
  },
  {
    id: 6,
    name: "Lorazepam",
    measure: "mg",
    stock: 123,
    price: 15500,
    status: "Available",
    instraction: "Before meal",
  },
  {
    id: 7,
    name: "Codeine",
    measure: "ml",
    stock: 1,
    price: 30000,
    status: "Available",
    instraction: "After meal",
  },
  {
    id: 8,
    name: "Tramadol",
    measure: "lb",
    stock: 0,
    price: 200,
    status: "Out of stock",
    instraction: "Before meal",
  },
];

export const patientTab = [
  {
    id: 0,
    title: "Vista 360°",
    icon: MdOutlinePanoramaPhotosphereSelect,
  },
  {
    id: 1,
    title: "Historial Medico",
    icon: TbChartHistogram,
  },
  {
    id: 2,
    title: "Agenda",
    icon: BiCalendar,
  },
  // {
  //   id: 3,
  //   title: 'Invoices',
  //   icon: RiFileList3Line,
  // },
  {
    id: 4,
    title: "Pagos",
    icon: RiMoneyDollarCircleLine,
  },
  // {
  //   id: 5,
  //   title: 'Imagenes',
  //   icon: RiImageLine,
  // },
  // {
  //   id: 6,
  //   title: 'Antecedentes Clinicos',
  //   icon: RiStethoscopeLine,
  // },
  {
    id: 7,
    title: "Informacion del paciente",
    icon: RiUserLine,
  },
  {
    id: 8,
    title: "Antecedentes Clinicos",
    icon: RiHeartLine,
  },
];

export const doctorTab = [
  {
    id: 1,
    title: "Personal Information",
    icon: RiUserLine,
  },
  {
    id: 2,
    title: "Patients",
    icon: BiUserPlus,
  },
  {
    id: 3,
    title: "Appointments",
    icon: BiCalendar,
  },
  {
    id: 4,
    title: "Payments",
    icon: RiMoneyDollarCircleLine,
  },
  {
    id: 5,
    title: "Invoices",
    icon: RiFileList3Line,
  },
  {
    id: 6,
    title: "Access Control",
    icon: TbLockAccess,
  },
  {
    id: 7,
    title: "Change Password",
    icon: RiLockPasswordLine,
  },
];

export const medicalRecodData = [
  {
    id: 1,
    date: "13, Enero 2023",
    amount: 150000,
    tipo: "Consulta",
    data: [
      {
        id: 1,
        title: "Sintomas",
        value: "Tos, Dolor de Cabeza, emorragia",
      },
      {
        id: 2,
        title: "Diagnostico",
        value: "Resfrio, Pulmonia",
      },
      {
        id: 3,
        title: "Prescripción",
        value: "Paracetamol, Amoxicillin, Ibuprofen, Aspirin",
      },
    ],
    attachments: [
      "https://placehold.it/300x300",
      "https://placehold.it/300x300",
      "https://placehold.it/300x300",
      "https://placehold.it/300x300",
    ],
    vitalSigns: [
      "Blood Pressure: 120/80 mmHg",
      "Pulse Rate: 80 bpm",
      "Respiratory Rate: 16 bpm",
      "Temperature: 36.5 °C",
      "Oxygen Saturation: 98%",
    ],
  },
  {
    id: 2,
    date: "13, Enero 2022",
    amount: 150000,
    tipo: "Control",
    data: [
      {
        id: 2,
        title: "Sintomas",
        value: "Tos, Dolor de Cabeza, emorragia",
      },
      {
        id: 2,
        title: "Diagnostico",
        value: "Resfrio, Pulmonia",
      },
      {
        id: 3,
        title: "Prescripción",
        value: "Paracetamol, Amoxicillin, Ibuprofen, Aspirin",
      },
    ],
    attachments: [
      "https://placehold.it/300x300",
      "https://placehold.it/300x300",
      "https://placehold.it/300x300",
      "https://placehold.it/300x300",
    ],
    vitalSigns: [
      "Blood Pressure: 120/80 mmHg",
      "Pulse Rate: 80 bpm",
      "Respiratory Rate: 16 bpm",
      "Temperature: 36.5 °C",
      "Oxygen Saturation: 98%",
    ],
  },
  {
    id: 3,
    date: "13, Enero 2021",
    amount: 150000,
    tipo: "Reconsulta",
    data: [
      {
        id: 1,
        title: "Sintomas",
        value: "Tos, Dolor de Cabeza, emorragia",
      },
      {
        id: 2,
        title: "Diagnostico",
        value: "Resfrio, Pulmonia",
      },
      {
        id: 3,
        title: "Prescripción",
        value: "Paracetamol, Amoxicillin, Ibuprofen, Aspirin",
      },
    ],
    attachments: [
      "https://placehold.it/300x300",
      "https://placehold.it/300x300",
      "https://placehold.it/300x300",
      "https://placehold.it/300x300",
    ],
    vitalSigns: [
      "Blood Pressure: 120/80 mmHg",
      "Pulse Rate: 80 bpm",
      "Respiratory Rate: 16 bpm",
      "Temperature: 36.5 °C",
      "Oxygen Saturation: 98%",
    ],
  },
];

export const doctorsData = [
  {
    id: 1,
    user: memberData[0],
    title: "Dr.",
  },
  {
    id: 2,
    user: memberData[1],
    title: "Dr.",
  },
  {
    id: 3,
    user: memberData[2],
    title: "Dr.",
  },
  {
    id: 4,
    user: memberData[3],
    title: "Dr.",
  },
];

export const receptionsData = [
  {
    id: 1,
    user: memberData[6],
    title: "Dr.",
  },
  {
    id: 2,
    user: memberData[7],
    title: "Dr.",
  },
  {
    id: 3,
    user: memberData[5],
    title: "Dr.",
  },
  {
    id: 4,
    user: memberData[4],
    title: "Dr.",
  },
  {
    id: 5,
    user: memberData[2],
    title: "Dr.",
  },
  {
    id: 6,
    user: memberData[1],
    title: "Dr.",
  },
];

export const Pediatrics = {
  /*  WeightMountGirls: {
    sdneg3: [
      2.0, 2.7, 3.4, 4.0, 4.4, 4.8, 5.1, 5.3, 5.6, 5.8, 5.9, 6.1, 6.3, 6.4, 6.6,
      6.7, 6.9, 7.0, 7.2, 7.3, 7.5, 7.6, 7.8, 7.9, 8.1, 8.2, 8.4, 8.5, 8.6, 8.8,
      8.9, 9.0, 9.1, 9.3, 9.4, 9.5, 9.6, 9.7, 9.8, 9.9, 10.1, 10.2, 10.3, 10.4,
      10.5, 10.6, 10.7, 10.8, 10.9, 11.0, 11.1, 11.2, 11.3, 11.4, 11.5, 11.6,
      11.7, 11.8, 11.9, 12.0, 12.1,
    ],
    sdneg2: [
      2.4, 3.2, 3.9, 4.5, 5.0, 5.4, 5.7, 6.0, 6.3, 6.5, 6.7, 6.9, 7.0, 7.2, 7.4,
      7.6, 7.7, 7.9, 8.1, 8.2, 8.4, 8.6, 8.7, 8.9, 9.0, 9.2, 9.4, 9.5, 9.7, 9.8,
      10.0, 10.1, 10.3, 10.4, 10.5, 10.7, 10.8, 10.9, 11.1, 11.2, 11.3, 11.5,
      11.6, 11.7, 11.8, 12.0, 12.1, 12.2, 12.3, 12.4, 12.6, 12.7, 12.8, 12.9,
      13.0, 13.2, 13.3, 13.4, 13.5, 13.6, 13.7,
    ],
    sdneg1: [
      2.8, 3.6, 4.5, 5.2, 5.7, 6.1, 6.5, 6.8, 7.0, 7.3, 7.5, 7.7, 7.9, 8.1, 8.3,
      8.5, 8.7, 8.9, 9.1, 9.2, 9.4, 9.6, 9.8, 10.0, 10.2, 10.3, 10.5, 10.7,
      10.9, 11.1, 11.2, 11.4, 11.6, 11.7, 11.9, 12.0, 12.2, 12.4, 12.5, 12.7,
      12.8, 13.0, 13.1, 13.3, 13.4, 13.6, 13.7, 13.9, 14.0, 14.2, 14.3, 14.5,
      14.6, 14.8, 14.9, 15.1, 15.2, 15.3, 15.5, 15.6, 15.8,
    ],
    median: [
      3.2, 4.2, 5.1, 5.8, 6.4, 6.9, 7.3, 7.6, 7.9, 8.2, 8.5, 8.7, 8.9, 9.2, 9.4,
      9.6, 9.8, 10.0, 10.2, 10.4, 10.6, 10.9, 11.1, 11.3, 11.5, 11.7, 11.9,
      12.1, 12.3, 12.5, 12.7, 12.9, 13.1, 13.3, 13.5, 13.7, 13.9, 14.0, 14.2,
      14.4, 14.6, 14.8, 15.0, 15.2, 15.3, 15.5, 15.7, 15.9, 16.1, 16.3, 16.4,
      16.6, 16.8, 17.0, 17.2, 17.3, 17.5, 17.7, 17.9, 18.0, 18.2,
    ],
    sd1: [
      3.7, 4.8, 5.8, 6.6, 7.3, 7.8, 8.2, 8.6, 9.0, 9.3, 9.6, 9.9, 10.1, 10.4,
      10.6, 10.9, 11.1, 11.4, 11.6, 11.8, 12.1, 12.3, 12.5, 12.8, 13.0, 13.3,
      13.5, 13.7, 14.0, 14.2, 14.4, 14.7, 14.9, 15.1, 15.4, 15.6, 15.8, 16.0,
      16.3, 16.5, 16.7, 16.9, 17.2, 17.4, 17.6, 17.8, 18.1, 18.3, 18.5, 18.8,
      19.0, 19.2, 19.4, 19.7, 19.9, 20.1, 20.3, 20.6, 20.8, 21.0, 21.2,
    ],
    sd2: [
      4.2, 5.5, 6.6, 7.5, 8.2, 8.8, 9.3, 9.8, 10.2, 10.5, 10.9, 11.2, 11.5,
      11.8, 12.1, 12.4, 12.6, 12.9, 13.2, 13.5, 13.7, 14.0, 14.3, 14.6, 14.8,
      15.1, 15.4, 15.7, 16.0, 16.2, 16.5, 16.8, 17.1, 17.3, 17.6, 17.9, 18.1,
      18.4, 18.7, 19.0, 19.2, 19.5, 19.8, 20.1, 20.4, 20.7, 20.9, 21.2, 21.5,
      21.8, 22.1, 22.4, 22.6, 22.9, 23.2, 23.5, 23.8, 24.1, 24.4, 24.6, 24.9,
    ],
    sd3: [
      4.8, 6.2, 7.5, 8.5, 9.3, 10.0, 10.6, 11.1, 11.6, 12.0, 12.4, 12.8, 13.1,
      13.5, 13.8, 14.1, 14.5, 14.8, 15.1, 15.4, 15.7, 16.0, 16.4, 16.7, 17.0,
      17.3, 17.7, 18.0, 18.3, 18.7, 19.0, 19.3, 19.6, 20.0, 20.3, 20.6, 20.9,
      21.3, 21.6, 22.0, 22.3, 22.7, 23.0, 23.4, 23.7, 24.1, 24.5, 24.8, 25.2,
      25.5, 25.9, 26.3, 26.6, 27.0, 27.4, 27.7, 28.1, 28.5, 28.8, 29.2, 29.5,
    ],
  },

  WeightMountBoys: {
    sdneg3: [
      2.1, 2.9, 3.8, 4.4, 4.9, 5.3, 5.7, 5.9, 6.2, 6.4, 6.6, 6.8, 6.9, 7.1, 7.2,
      7.4, 7.5, 7.7, 7.8, 8.0, 8.1, 8.2, 8.4, 8.5, 8.6, 8.8, 8.9, 9.0, 9.1, 9.2,
      9.4, 9.5, 9.6, 9.7, 9.8, 9.9, 10.0, 10.1, 10.2, 10.3, 10.4, 10.5, 10.6,
      10.7, 10.8, 10.9, 11.0, 11.1, 11.2, 11.3, 11.4, 11.5, 11.6, 11.7, 11.8,
      11.9, 12.0, 12.1, 12.2, 12.3, 12.4,
    ],
    sdneg2: [
      2.5, 3.4, 4.3, 5.0, 5.6, 6.0, 6.4, 6.7, 6.9, 7.1, 7.4, 7.6, 7.7, 7.9, 8.1,
      8.3, 8.4, 8.6, 8.8, 8.9, 9.1, 9.2, 9.4, 9.5, 9.7, 9.8, 10.0, 10.1, 10.2,
      10.4, 10.5, 10.7, 10.8, 10.9, 11.0, 11.2, 11.3, 11.4, 11.5, 11.6, 11.8,
      11.9, 12.0, 12.1, 12.2, 12.4, 12.5, 12.6, 12.7, 12.8, 12.9, 13.1, 13.2,
      13.3, 13.4, 13.5, 13.6, 13.7, 13.8, 14.0, 14.1,
    ],
    sdneg1: [
      2.9, 3.9, 4.9, 5.7, 6.2, 6.7, 7.1, 7.4, 7.7, 8.0, 8.2, 8.4, 8.6, 8.8, 9.0,
      9.2, 9.4, 9.6, 9.8, 10.0, 10.1, 10.3, 10.5, 10.7, 10.8, 11.0, 11.2, 11.3,
      11.5, 11.7, 11.8, 12.0, 12.1, 12.3, 12.4, 12.6, 12.7, 12.9, 13.0, 13.1,
      13.3, 13.4, 13.6, 13.7, 13.8, 14.0, 14.1, 14.3, 14.4, 14.5, 14.7, 14.8,
      15.0, 15.1, 15.2, 15.4, 15.5, 15.6, 15.8, 15.9, 16.0,
    ],
    median: [
      3.3, 4.5, 5.6, 6.4, 7.0, 7.5, 7.9, 8.3, 8.6, 8.9, 9.2, 9.4, 9.6, 9.9,
      10.1, 10.3, 10.5, 10.7, 10.9, 11.1, 11.3, 11.5, 11.8, 12.0, 12.2, 12.4,
      12.5, 12.7, 12.9, 13.1, 13.3, 13.5, 13.7, 13.8, 14.0, 14.2, 14.3, 14.5,
      14.7, 14.8, 15.0, 15.2, 15.3, 15.5, 15.7, 15.8, 16.0, 16.2, 16.3, 16.5,
      16.7, 16.8, 17.0, 17.2, 17.3, 17.5, 17.7, 17.8, 18.0, 18.2, 18.3,
    ],
    sd1: [
      3.9, 5.1, 6.3, 7.2, 7.8, 8.4, 8.8, 9.2, 9.6, 9.9, 10.2, 10.5, 10.8, 11.0,
      11.3, 11.5, 11.7, 12.0, 12.2, 12.5, 12.7, 12.9, 13.2, 13.4, 13.6, 13.9,
      14.1, 14.3, 14.5, 14.8, 15.0, 15.2, 15.4, 15.6, 15.8, 16.0, 16.2, 16.4,
      16.6, 16.8, 17.0, 17.2, 17.4, 17.6, 17.8, 18.0, 18.2, 18.4, 18.6, 18.8,
      19.0, 19.2, 19.4, 19.6, 19.8, 20.0, 20.2, 20.4, 20.6, 20.8, 21.0,
    ],
    sd2: [
      4.4, 5.8, 7.1, 8.0, 8.7, 9.3, 9.8, 10.3, 10.7, 11.0, 11.4, 11.7, 12.0,
      12.3, 12.6, 12.8, 13.1, 13.4, 13.7, 13.9, 14.2, 14.5, 14.7, 15.0, 15.3,
      15.5, 15.8, 16.1, 16.3, 16.6, 16.9, 17.1, 17.4, 17.6, 17.8, 18.1, 18.3,
      18.6, 18.8, 19.0, 19.3, 19.5, 19.7, 20.0, 20.2, 20.5, 20.7, 20.9, 21.2,
      21.4, 21.7, 21.9, 22.2, 22.4, 22.7, 22.9, 23.2, 23.4, 23.7, 23.9, 24.2,
    ],
    sd3: [
      5.0, 6.6, 8.0, 9.0, 9.7, 10.4, 10.9, 11.4, 11.9, 12.3, 12.7, 13.0, 13.3,
      13.7, 14.0, 14.3, 14.6, 14.9, 15.3, 15.6, 15.9, 16.2, 16.5, 16.8, 17.1,
      17.5, 17.8, 18.1, 18.4, 18.7, 19.0, 19.3, 19.6, 19.9, 20.2, 20.4, 20.7,
      21.0, 21.3, 21.6, 21.9, 22.1, 22.4, 22.7, 23.0, 23.3, 23.6, 23.9, 24.2,
      24.5, 24.8, 25.1, 25.4, 25.7, 26.0, 26.3, 26.6, 26.9, 27.2, 27.6, 27.9,
    ],
  },

  LengthMountGirls: {
    sdneg3: [
      43.6, 47.8, 51.0, 53.5, 55.6, 57.4, 58.9, 60.3, 61.7, 62.9, 64.1, 65.2,
      66.3, 67.3, 68.3, 69.3, 70.2, 71.1, 72.0, 72.8, 73.7, 74.5, 75.2, 76.0,
      76.8, 77.5, 78.1, 78.8, 79.5, 80.1, 80.7, 81.3, 81.9, 82.5, 83.1, 83.6,
      84.2, 84.7, 85.3, 85.8, 86.3, 86.8, 87.4, 87.9, 88.4, 88.9, 89.3, 89.8,
      90.3, 90.7, 91.2, 91.7, 92.1, 92.6, 93.0, 93.4, 93.9, 94.3, 94.7, 95.2,
    ],
    sdneg2: [
      45.4, 49.8, 53.0, 55.6, 57.8, 59.6, 61.2, 62.7, 64.0, 65.3, 66.5, 67.7,
      68.9, 70.0, 71.0, 72.0, 73.0, 74.0, 74.9, 75.8, 76.7, 77.5, 78.4, 79.3,
      80.0, 80.8, 81.5, 82.2, 82.9, 83.6, 84.3, 84.9, 85.6, 86.2, 86.8, 87.4,
      88.0, 88.6, 89.2, 89.8, 90.4, 90.9, 91.5, 92.0, 92.5, 93.1, 93.6, 94.1,
      94.6, 95.1, 95.6, 96.1, 96.6, 97.1, 97.6, 98.1, 98.5, 99.0, 99.5, 99.9,
    ],
    sdneg1: [
      47.3, 51.7, 55.0, 57.7, 59.9, 61.8, 63.5, 65.0, 66.4, 67.7, 69.0, 70.3,
      71.4, 72.6, 73.7, 74.8, 75.8, 76.8, 77.8, 78.8, 79.7, 80.6, 81.5, 82.5,
      83.3, 84.1, 84.9, 85.7, 86.4, 87.1, 87.9, 88.6, 89.3, 89.9, 90.6, 91.2,
      91.9, 92.5, 93.1, 93.8, 94.4, 95.0, 95.6, 96.2, 96.7, 97.3, 97.9, 98.4,
      99.0, 99.5, 100.1, 100.6, 101.1, 101.6, 102.2, 102.7, 103.2, 103.7, 104.2,
      104.7,
    ],
    median: [
      49.1, 53.7, 57.1, 59.8, 62.1, 64.0, 65.7, 67.3, 68.7, 70.1, 71.5, 72.8,
      74.0, 75.2, 76.4, 77.5, 78.6, 79.7, 80.7, 81.7, 82.7, 83.7, 84.6, 85.7,
      86.6, 87.4, 88.3, 89.1, 89.9, 90.7, 91.4, 92.2, 92.9, 93.6, 94.4, 95.1,
      95.7, 96.4, 97.1, 97.7, 98.4, 99.0, 99.7, 100.3, 100.9, 101.5, 102.1,
      102.7, 103.3, 103.9, 104.5, 105.0, 105.6, 106.2, 106.7, 107.3, 107.8,
      108.4, 108.9, 109.4,
    ],
    sd1: [
      51.0, 55.6, 59.1, 61.9, 64.3, 66.2, 68.0, 69.6, 71.1, 72.6, 73.9, 75.3,
      76.6, 77.8, 79.1, 80.2, 81.4, 82.5, 83.6, 84.7, 85.7, 86.7, 87.7, 88.9,
      89.9, 90.8, 91.7, 92.5, 93.4, 94.2, 95.0, 95.8, 96.6, 97.4, 98.1, 98.9,
      99.6, 100.3, 101.0, 101.7, 102.4, 103.1, 103.8, 104.5, 105.1, 105.8,
      106.4, 107.0, 107.7, 108.3, 108.9, 109.5, 110.1, 110.7, 111.3, 111.9,
      112.5, 113.0, 113.6, 114.2,
    ],
    sd2: [
      52.9, 57.6, 61.1, 64.0, 66.4, 68.5, 70.3, 71.9, 73.5, 75.0, 76.4, 77.8,
      79.2, 80.5, 81.7, 83.0, 84.2, 85.4, 86.5, 87.6, 88.7, 89.8, 90.8, 92.2,
      93.1, 94.1, 95.0, 96.0, 96.9, 97.7, 98.6, 99.4, 100.3, 101.1, 101.9,
      102.7, 103.4, 104.2, 105.0, 105.7, 106.4, 107.2, 107.9, 108.6, 109.3,
      110.0, 110.7, 111.3, 112.0, 112.7, 113.3, 114.0, 114.6, 115.2, 115.9,
      116.5, 117.1, 117.7, 118.3, 118.9,
    ],
    sd3: [
      54.7, 59.5, 63.2, 66.1, 68.6, 70.7, 72.5, 74.2, 75.8, 77.4, 78.9, 80.3,
      81.7, 83.1, 84.4, 85.7, 87.0, 88.2, 89.4, 90.6, 91.7, 92.9, 94.0, 95.4,
      96.4, 97.4, 98.4, 99.4, 100.3, 101.3, 102.2, 103.1, 103.9, 104.8, 105.6,
      106.5, 107.3, 108.1, 108.9, 109.7, 110.5, 111.2, 112.0, 112.7, 113.5,
      114.2, 114.9, 115.7, 116.4, 117.1, 117.7, 118.4, 119.1, 119.8, 120.4,
      121.1, 121.8, 122.4, 123.1, 123.7,
    ],
  },

  LengthMountBoys: {
    sdneg3: [
      44.2, 48.9, 52.4, 55.3, 57.6, 59.6, 61.2, 62.7, 64.0, 65.2, 66.4, 67.6,
      68.6, 69.6, 70.6, 71.6, 72.5, 73.3, 74.2, 75.0, 75.8, 76.5, 77.2, 78.0,
      78.7, 79.3, 79.9, 80.5, 81.1, 81.7, 82.3, 82.8, 83.4, 83.9, 84.4, 85.0,
      85.5, 86.0, 86.5, 87.0, 87.5, 88.0, 88.4, 88.9, 89.4, 89.8, 90.3, 90.7,
      91.2, 91.6, 92.1, 92.5, 93.0, 93.4, 93.9, 94.3, 94.7, 95.2, 95.6, 96.1,
    ],
    sdneg2: [
      46.1, 50.8, 54.4, 57.3, 59.7, 61.7, 63.3, 64.8, 66.2, 67.5, 68.7, 69.9,
      71.0, 72.1, 73.1, 74.1, 75.0, 76.0, 76.9, 77.7, 78.6, 79.4, 80.2, 81.0,
      81.7, 82.5, 83.1, 83.8, 84.5, 85.1, 85.7, 86.4, 86.9, 87.5, 88.1, 88.7,
      89.2, 89.8, 90.3, 90.9, 91.4, 91.9, 92.4, 93.0, 93.5, 94.0, 94.4, 94.9,
      95.4, 95.9, 96.4, 96.9, 97.4, 97.8, 98.3, 98.8, 99.3, 99.7, 100.2, 100.7,
    ],
    sdneg1: [
      48.0, 52.8, 56.4, 59.4, 61.8, 63.8, 65.5, 67.0, 68.4, 69.7, 71.0, 72.2,
      73.4, 74.5, 75.6, 76.6, 77.6, 78.6, 79.6, 80.5, 81.4, 82.3, 83.1, 83.9,
      84.8, 85.6, 86.4, 87.1, 87.8, 88.5, 89.2, 89.9, 90.5, 91.1, 91.8, 92.4,
      93.0, 93.6, 94.2, 94.7, 95.3, 95.9, 96.4, 97.0, 97.5, 98.1, 98.6, 99.1,
      99.7, 100.2, 100.7, 101.2, 101.7, 102.3, 102.8, 103.3, 103.8, 104.3,
      104.8, 105.3,
    ],
    median: [
      49.9, 54.7, 58.4, 61.4, 63.9, 65.9, 67.6, 69.2, 70.6, 72.0, 73.3, 74.5,
      75.7, 76.9, 78.0, 79.1, 80.2, 81.2, 82.3, 83.2, 84.2, 85.1, 86.0, 86.9,
      87.8, 88.8, 89.6, 90.4, 91.2, 91.9, 92.7, 93.4, 94.1, 94.8, 95.4, 96.1,
      96.7, 97.4, 98.0, 98.6, 99.2, 99.9, 100.4, 101.0, 101.6, 102.2, 102.8,
      103.3, 103.9, 104.4, 105.0, 105.6, 106.1, 106.7, 107.2, 107.8, 108.3,
      108.9, 109.4, 110.0,
    ],
    sd1: [
      51.8, 56.7, 60.4, 63.5, 66.0, 68.0, 69.8, 71.3, 72.8, 74.2, 75.6, 76.9,
      78.1, 79.3, 80.5, 81.7, 82.8, 83.9, 85.0, 86.0, 87.0, 88.0, 89.0, 89.9,
      90.9, 92.0, 92.9, 93.7, 94.5, 95.3, 96.1, 96.9, 97.6, 98.4, 99.1, 99.8,
      100.5, 101.2, 101.8, 102.5, 103.2, 103.8, 104.5, 105.1, 105.7, 106.3,
      106.9, 107.5, 108.1, 108.7, 109.3, 109.9, 110.5, 111.1, 111.7, 112.3,
      112.8, 113.4, 114.0, 114.6,
    ],
    sd2: [
      53.7, 58.6, 62.4, 65.5, 68.0, 70.1, 71.9, 73.5, 75.0, 76.5, 77.9, 79.2,
      80.5, 81.8, 83.0, 84.2, 85.4, 86.5, 87.7, 88.8, 89.8, 90.9, 91.9, 92.9,
      93.9, 95.2, 96.1, 97.0, 97.9, 98.7, 99.6, 100.4, 101.2, 102.0, 102.7,
      103.5, 104.2, 105.0, 105.7, 106.4, 107.1, 107.8, 108.5, 109.1, 109.8,
      110.4, 111.1, 111.7, 112.4, 113.0, 113.6, 114.2, 114.9, 115.5, 116.1,
      116.7, 117.4, 118.0, 118.6, 119.2,
    ],
    sd3: [
      55.6, 60.6, 64.4, 67.6, 70.1, 72.2, 74.0, 75.7, 77.2, 78.7, 80.1, 81.5,
      82.9, 84.2, 85.5, 86.7, 88.0, 89.2, 90.4, 91.5, 92.6, 93.8, 94.9, 95.9,
      97.0, 98.3, 99.3, 100.3, 101.2, 102.1, 103.0, 103.9, 104.8, 105.6, 106.4,
      107.2, 108.0, 108.8, 109.5, 110.3, 111.0, 111.7, 112.5, 113.2, 113.9,
      114.6, 115.2, 115.9, 116.6, 117.3, 117.9, 118.6, 119.2, 119.9, 120.6,
      121.2, 121.9, 122.6, 123.2, 123.9,
    ],
  },

  WeightLengthGirls02: {
    sdneg3: [
      1.9, 2.0, 2.0, 2.1, 2.2, 2.2, 2.3, 2.4, 2.4, 2.5, 2.6, 2.7, 2.8, 2.8, 2.9,
      3.0, 3.1, 3.2, 3.3, 3.4, 3.5, 3.6, 3.7, 3.8, 3.9, 4.0, 4.1, 4.2, 4.3, 4.4,
      4.5, 4.6, 4.7, 4.8, 4.9, 5.0, 5.1, 5.2, 5.3, 5.4, 5.5, 5.5, 5.6, 5.7, 5.8,
      5.9, 6.0, 6.1, 6.1, 6.2, 6.3, 6.4, 6.5, 6.5, 6.6, 6.7, 6.8, 6.9, 6.9, 7.0,
      7.1, 7.1, 7.2, 7.3, 7.4, 7.4, 7.5, 7.6, 7.7, 7.7, 7.8, 7.9, 8.0, 8.1, 8.1,
      8.2, 8.3, 8.4, 8.5, 8.6, 8.7, 8.8, 8.9, 9.0, 9.1, 9.2, 9.3, 9.4, 9.5, 9.6,
      9.7, 9.8, 9.9, 10.0, 10.1, 10.1, 10.2, 10.3, 10.4, 10.5, 10.6, 10.7, 10.8,
      10.9, 11.0, 11.1, 11.2, 11.3, 11.4, 11.5, 11.6, 11.7, 11.8, 11.9, 12.0,
      12.1, 12.3, 12.4, 12.5, 12.6, 12.7, 12.8, 13.0, 13.1, 13.2, 13.3, 13.5,
      13.6, 13.7, 13.9, 14.0,
    ],
    sdneg2: [
      2.1, 2.1, 2.2, 2.3, 2.4, 2.4, 2.5, 2.6, 2.6, 2.7, 2.8, 2.9, 3.0, 3.1, 3.2,
      3.3, 3.4, 3.5, 3.6, 3.7, 3.8, 3.9, 4.0, 4.1, 4.3, 4.4, 4.5, 4.6, 4.7, 4.8,
      4.9, 5.0, 5.1, 5.2, 5.3, 5.4, 5.5, 5.6, 5.7, 5.8, 5.9, 6.0, 6.1, 6.2, 6.3,
      6.4, 6.5, 6.6, 6.7, 6.8, 6.9, 6.9, 7.0, 7.1, 7.2, 7.3, 7.4, 7.4, 7.5, 7.6,
      7.7, 7.8, 7.8, 7.9, 8.0, 8.1, 8.2, 8.2, 8.3, 8.4, 8.5, 8.6, 8.7, 8.8, 8.8,
      8.9, 9.0, 9.1, 9.2, 9.3, 9.4, 9.5, 9.7, 9.8, 9.9, 10.0, 10.1, 10.2, 10.3,
      10.4, 10.5, 10.6, 10.7, 10.8, 10.9, 11.0, 11.1, 11.2, 11.3, 11.4, 11.5,
      11.6, 11.7, 11.8, 12.0, 12.1, 12.2, 12.3, 12.4, 12.5, 12.6, 12.7, 12.8,
      13.0, 13.1, 13.2, 13.3, 13.5, 13.6, 13.7, 13.8, 14.0, 14.1, 14.3, 14.4,
      14.5, 14.7, 14.8, 15.0, 15.1, 15.3,
    ],
    sdneg1: [
      2.3, 2.3, 2.4, 2.5, 2.6, 2.6, 2.7, 2.8, 2.9, 3.0, 3.1, 3.2, 3.3, 3.4, 3.5,
      3.6, 3.7, 3.8, 3.9, 4.0, 4.2, 4.3, 4.4, 4.5, 4.6, 4.8, 4.9, 5.0, 5.1, 5.3,
      5.4, 5.5, 5.6, 5.7, 5.8, 5.9, 6.0, 6.2, 6.3, 6.4, 6.5, 6.6, 6.7, 6.8, 6.9,
      7.0, 7.1, 7.2, 7.3, 7.4, 7.5, 7.6, 7.7, 7.7, 7.8, 7.9, 8.0, 8.1, 8.2, 8.3,
      8.4, 8.5, 8.5, 8.6, 8.7, 8.8, 8.9, 9.0, 9.1, 9.1, 9.2, 9.3, 9.4, 9.5, 9.6,
      9.7, 9.8, 9.9, 10.1, 10.2, 10.3, 10.4, 10.5, 10.6, 10.7, 10.9, 11.0, 11.1,
      11.2, 11.3, 11.4, 11.5, 11.7, 11.8, 11.9, 12.0, 12.1, 12.2, 12.3, 12.4,
      12.6, 12.7, 12.8, 12.9, 13.0, 13.1, 13.3, 13.4, 13.5, 13.6, 13.7, 13.9,
      14.0, 14.1, 14.3, 14.4, 14.5, 14.7, 14.8, 15.0, 15.1, 15.3, 15.4, 15.6,
      15.7, 15.9, 16.0, 16.2, 16.4, 16.5, 16.7,
    ],
    median: [
      2.5, 2.5, 2.6, 2.7, 2.8, 2.9, 3.0, 3.1, 3.2, 3.3, 3.4, 3.5, 3.6, 3.7, 3.8,
      3.9, 4.0, 4.2, 4.3, 4.4, 4.5, 4.7, 4.8, 5.0, 5.1, 5.2, 5.4, 5.5, 5.6, 5.7,
      5.9, 6.0, 6.1, 6.3, 6.4, 6.5, 6.6, 6.7, 6.9, 7.0, 7.1, 7.2, 7.3, 7.4, 7.5,
      7.6, 7.7, 7.9, 8.0, 8.1, 8.2, 8.3, 8.4, 8.5, 8.6, 8.7, 8.8, 8.9, 9.0, 9.1,
      9.1, 9.2, 9.3, 9.4, 9.5, 9.6, 9.7, 9.8, 9.9, 10.0, 10.1, 10.2, 10.3, 10.4,
      10.5, 10.6, 10.7, 10.9, 11.0, 11.1, 11.2, 11.3, 11.5, 11.6, 11.7, 11.8,
      12.0, 12.1, 12.2, 12.3, 12.5, 12.6, 12.7, 12.8, 13.0, 13.1, 13.2, 13.3,
      13.5, 13.6, 13.7, 13.8, 14.0, 14.1, 14.2, 14.4, 14.5, 14.6, 14.8, 14.9,
      15.0, 15.2, 15.3, 15.5, 15.6, 15.8, 15.9, 16.1, 16.2, 16.4, 16.5, 16.7,
      16.9, 17.1, 17.2, 17.4, 17.6, 17.8, 18.0, 18.1, 18.3,
    ],
    sd1: [
      2.7, 2.8, 2.9, 3.0, 3.1, 3.2, 3.3, 3.4, 3.5, 3.6, 3.7, 3.8, 3.9, 4.0, 4.2,
      4.3, 4.4, 4.6, 4.7, 4.8, 5.0, 5.1, 5.3, 5.4, 5.6, 5.7, 5.9, 6.0, 6.2, 6.3,
      6.4, 6.6, 6.7, 6.9, 7.0, 7.1, 7.3, 7.4, 7.5, 7.6, 7.8, 7.9, 8.0, 8.1, 8.3,
      8.4, 8.5, 8.6, 8.7, 8.8, 9.0, 9.1, 9.2, 9.3, 9.4, 9.5, 9.6, 9.7, 9.8, 9.9,
      10.0, 10.1, 10.2, 10.3, 10.4, 10.5, 10.6, 10.7, 10.8, 10.9, 11.0, 11.2,
      11.3, 11.4, 11.5, 11.6, 11.8, 11.9, 12.0, 12.1, 12.3, 12.4, 12.6, 12.7,
      12.8, 13.0, 13.1, 13.2, 13.4, 13.5, 13.7, 13.8, 13.9, 14.1, 14.2, 14.3,
      14.5, 14.6, 14.7, 14.9, 15.0, 15.2, 15.3, 15.4, 15.6, 15.7, 15.9, 16.0,
      16.2, 16.3, 16.5, 16.6, 16.8, 17.0, 17.1, 17.3, 17.5, 17.6, 17.8, 18.0,
      18.2, 18.4, 18.5, 18.7, 18.9, 19.1, 19.3, 19.5, 19.7, 20.0, 20.2,
    ],
    sd2: [
      3.0, 3.1, 3.2, 3.3, 3.4, 3.5, 3.6, 3.7, 3.8, 3.9, 4.0, 4.2, 4.3, 4.4, 4.6,
      4.7, 4.9, 5.0, 5.2, 5.3, 5.5, 5.7, 5.8, 6.0, 6.1, 6.3, 6.5, 6.6, 6.8, 6.9,
      7.1, 7.3, 7.4, 7.6, 7.7, 7.8, 8.0, 8.1, 8.3, 8.4, 8.6, 8.7, 8.8, 9.0, 9.1,
      9.2, 9.4, 9.5, 9.6, 9.7, 9.9, 10.0, 10.1, 10.2, 10.3, 10.5, 10.6, 10.7,
      10.8, 10.9, 11.0, 11.1, 11.2, 11.4, 11.5, 11.6, 11.7, 11.8, 11.9, 12.0,
      12.1, 12.3, 12.4, 12.5, 12.6, 12.8, 12.9, 13.1, 13.2, 13.3, 13.5, 13.6,
      13.8, 13.9, 14.1, 14.2, 14.4, 14.5, 14.7, 14.8, 15.0, 15.1, 15.3, 15.5,
      15.6, 15.8, 15.9, 16.1, 16.2, 16.4, 16.5, 16.7, 16.8, 17.0, 17.1, 17.3,
      17.5, 17.6, 17.8, 18.0, 18.1, 18.3, 18.5, 18.7, 18.9, 19.0, 19.2, 19.4,
      19.6, 19.8, 20.0, 20.2, 20.5, 20.7, 20.9, 21.1, 21.3, 21.6, 21.8, 22.0,
      22.3,
    ],
    sd3: [
      3.3, 3.4, 3.5, 3.6, 3.7, 3.8, 4.0, 4.1, 4.2, 4.3, 4.5, 4.6, 4.8, 4.9, 5.1,
      5.2, 5.4, 5.5, 5.7, 5.9, 6.1, 6.3, 6.4, 6.6, 6.8, 7.0, 7.1, 7.3, 7.5, 7.7,
      7.8, 8.0, 8.2, 8.4, 8.5, 8.7, 8.8, 9.0, 9.1, 9.3, 9.5, 9.6, 9.8, 9.9,
      10.0, 10.2, 10.3, 10.5, 10.6, 10.7, 10.9, 11.0, 11.1, 11.3, 11.4, 11.5,
      11.7, 11.8, 11.9, 12.0, 12.2, 12.3, 12.4, 12.5, 12.6, 12.8, 12.9, 13.0,
      13.1, 13.3, 13.4, 13.5, 13.7, 13.8, 13.9, 14.1, 14.2, 14.4, 14.5, 14.7,
      14.9, 15.0, 15.2, 15.4, 15.5, 15.7, 15.9, 16.0, 16.2, 16.4, 16.5, 16.7,
      16.9, 17.0, 17.2, 17.4, 17.5, 17.7, 17.9, 18.0, 18.2, 18.4, 18.6, 18.7,
      18.9, 19.1, 19.3, 19.5, 19.6, 19.8, 20.0, 20.2, 20.4, 20.6, 20.8, 21.0,
      21.3, 21.5, 21.7, 21.9, 22.2, 22.4, 22.6, 22.9, 23.1, 23.4, 23.6, 23.9,
      24.2, 24.4, 24.7,
    ],
  },

  WeightLengthBoys02: {
    sdneg3: [
      1.9, 1.9, 2.0, 2.1, 2.1, 2.2, 2.3, 2.3, 2.4, 2.5, 2.6, 2.7, 2.7, 2.8, 2.9,
      3.0, 3.1, 3.2, 3.3, 3.4, 3.6, 3.7, 3.8, 3.9, 4.0, 4.1, 4.3, 4.4, 4.5, 4.6,
      4.7, 4.8, 4.9, 5.0, 5.1, 5.2, 5.3, 5.4, 5.5, 5.6, 5.7, 5.8, 5.9, 6.0, 6.1,
      6.2, 6.3, 6.4, 6.5, 6.6, 6.6, 6.7, 6.8, 6.9, 7.0, 7.1, 7.2, 7.2, 7.3, 7.4,
      7.5, 7.6, 7.6, 7.7, 7.8, 7.9, 7.9, 8.0, 8.1, 8.2, 8.2, 8.3, 8.4, 8.5, 8.5,
      8.6, 8.7, 8.8, 8.9, 9.0, 9.1, 9.2, 9.3, 9.4, 9.5, 9.6, 9.7, 9.8, 9.9,
      10.0, 10.1, 10.2, 10.3, 10.4, 10.5, 10.6, 10.7, 10.7, 10.8, 10.9, 11.0,
      11.1, 11.2, 11.3, 11.4, 11.5, 11.6, 11.7, 11.8, 11.9, 12.0, 12.1, 12.2,
      12.3, 12.4, 12.5, 12.6, 12.7, 12.8, 12.9, 13.0, 13.2, 13.3, 13.4, 13.5,
      13.6, 13.7, 13.8, 14.0, 14.1, 14.2,
    ],
    sdneg2: [
      2.0, 2.1, 2.2, 2.3, 2.3, 2.4, 2.5, 2.6, 2.6, 2.7, 2.8, 2.9, 3.0, 3.1, 3.2,
      3.3, 3.4, 3.5, 3.6, 3.7, 3.8, 4.0, 4.1, 4.2, 4.3, 4.5, 4.6, 4.7, 4.8, 5.0,
      5.1, 5.2, 5.3, 5.4, 5.6, 5.7, 5.8, 5.9, 6.0, 6.1, 6.2, 6.3, 6.4, 6.5, 6.6,
      6.7, 6.8, 6.9, 7.0, 7.1, 7.2, 7.3, 7.4, 7.5, 7.6, 7.6, 7.7, 7.8, 7.9, 8.0,
      8.1, 8.2, 8.3, 8.3, 8.4, 8.5, 8.6, 8.7, 8.7, 8.8, 8.9, 9.0, 9.1, 9.1, 9.2,
      9.3, 9.4, 9.5, 9.6, 9.7, 9.8, 9.9, 10.0, 10.1, 10.2, 10.4, 10.5, 10.6,
      10.7, 10.8, 10.9, 11.0, 11.1, 11.2, 11.3, 11.4, 11.5, 11.6, 11.7, 11.8,
      11.9, 12.0, 12.1, 12.2, 12.3, 12.4, 12.5, 12.6, 12.7, 12.8, 12.9, 13.0,
      13.2, 13.3, 13.4, 13.5, 13.6, 13.7, 13.9, 14.0, 14.1, 14.2, 14.4, 14.5,
      14.6, 14.7, 14.9, 15.0, 15.1, 15.3, 15.4,
    ],
    sdneg1: [
      2.2, 2.3, 2.4, 2.5, 2.5, 2.6, 2.7, 2.8, 2.9, 3.0, 3.0, 3.1, 3.2, 3.3, 3.5,
      3.6, 3.7, 3.8, 3.9, 4.0, 4.2, 4.3, 4.4, 4.6, 4.7, 4.9, 5.0, 5.1, 5.3, 5.4,
      5.5, 5.6, 5.8, 5.9, 6.0, 6.1, 6.2, 6.4, 6.5, 6.6, 6.7, 6.8, 6.9, 7.0, 7.1,
      7.2, 7.3, 7.5, 7.6, 7.7, 7.8, 7.9, 8.0, 8.1, 8.2, 8.3, 8.4, 8.5, 8.6, 8.7,
      8.8, 8.8, 8.9, 9.0, 9.1, 9.2, 9.3, 9.4, 9.5, 9.5, 9.6, 9.7, 9.8, 9.9,
      10.0, 10.1, 10.2, 10.3, 10.4, 10.5, 10.6, 10.7, 10.8, 11.0, 11.1, 11.2,
      11.3, 11.4, 11.5, 11.6, 11.8, 11.9, 12.0, 12.1, 12.2, 12.3, 12.4, 12.5,
      12.6, 12.7, 12.8, 12.9, 13.1, 13.2, 13.3, 13.4, 13.5, 13.6, 13.7, 13.9,
      14.0, 14.1, 14.2, 14.4, 14.5, 14.6, 14.8, 14.9, 15.0, 15.2, 15.3, 15.4,
      15.6, 15.7, 15.9, 16.0, 16.2, 16.3, 16.5, 16.6, 16.8,
    ],
    median: [
      2.4, 2.5, 2.6, 2.7, 2.8, 2.9, 2.9, 3.0, 3.1, 3.2, 3.3, 3.4, 3.5, 3.6, 3.8,
      3.9, 4.0, 4.1, 4.3, 4.4, 4.5, 4.7, 4.8, 5.0, 5.1, 5.3, 5.4, 5.6, 5.7, 5.9,
      6.0, 6.1, 6.3, 6.4, 6.5, 6.7, 6.8, 6.9, 7.0, 7.1, 7.3, 7.4, 7.5, 7.6, 7.7,
      7.9, 8.0, 8.1, 8.2, 8.3, 8.4, 8.5, 8.6, 8.8, 8.9, 9.0, 9.1, 9.2, 9.3, 9.4,
      9.5, 9.6, 9.7, 9.8, 9.9, 10.0, 10.1, 10.2, 10.3, 10.4, 10.4, 10.5, 10.6,
      10.7, 10.8, 10.9, 11.0, 11.2, 11.3, 11.4, 11.5, 11.6, 11.7, 11.9, 12.0,
      12.1, 12.2, 12.4, 12.5, 12.6, 12.7, 12.8, 13.0, 13.1, 13.2, 13.3, 13.4,
      13.5, 13.7, 13.8, 13.9, 14.0, 14.1, 14.3, 14.4, 14.5, 14.6, 14.8, 14.9,
      15.0, 15.2, 15.3, 15.4, 15.6, 15.7, 15.9, 16.0, 16.2, 16.3, 16.5, 16.6,
      16.8, 16.9, 17.1, 17.3, 17.4, 17.6, 17.8, 17.9, 18.1, 18.3,
    ],
    sd1: [
      2.7, 2.8, 2.9, 3.0, 3.0, 3.1, 3.2, 3.3, 3.4, 3.5, 3.6, 3.8, 3.9, 4.0, 4.1,
      4.2, 4.4, 4.5, 4.7, 4.8, 5.0, 5.1, 5.3, 5.4, 5.6, 5.7, 5.9, 6.1, 6.2, 6.4,
      6.5, 6.7, 6.8, 7.0, 7.1, 7.2, 7.4, 7.5, 7.6, 7.8, 7.9, 8.0, 8.2, 8.3, 8.4,
      8.5, 8.7, 8.8, 8.9, 9.0, 9.2, 9.3, 9.4, 9.5, 9.6, 9.8, 9.9, 10.0, 10.1,
      10.2, 10.3, 10.4, 10.6, 10.7, 10.8, 10.9, 11.0, 11.1, 11.2, 11.3, 11.4,
      11.5, 11.6, 11.7, 11.8, 11.9, 12.0, 12.1, 12.2, 12.4, 12.5, 12.6, 12.8,
      12.9, 13.0, 13.2, 13.3, 13.4, 13.5, 13.7, 13.8, 13.9, 14.1, 14.2, 14.3,
      14.4, 14.6, 14.7, 14.8, 14.9, 15.1, 15.2, 15.3, 15.5, 15.6, 15.7, 15.9,
      16.0, 16.2, 16.3, 16.5, 16.6, 16.8, 16.9, 17.1, 17.3, 17.4, 17.6, 17.8,
      17.9, 18.1, 18.3, 18.5, 18.6, 18.8, 19.0, 19.2, 19.4, 19.6, 19.8, 20.0,
    ],
    sd2: [
      3.0, 3.1, 3.1, 3.2, 3.3, 3.4, 3.6, 3.7, 3.8, 3.9, 4.0, 4.1, 4.2, 4.4, 4.5,
      4.6, 4.8, 4.9, 5.1, 5.3, 5.4, 5.6, 5.8, 5.9, 6.1, 6.3, 6.4, 6.6, 6.8, 7.0,
      7.1, 7.3, 7.4, 7.6, 7.7, 7.9, 8.0, 8.2, 8.3, 8.5, 8.6, 8.7, 8.9, 9.0, 9.2,
      9.3, 9.4, 9.6, 9.7, 9.8, 10.0, 10.1, 10.2, 10.4, 10.5, 10.6, 10.8, 10.9,
      11.0, 11.2, 11.3, 11.4, 11.5, 11.6, 11.7, 11.9, 12.0, 12.1, 12.2, 12.3,
      12.4, 12.5, 12.6, 12.7, 12.8, 13.0, 13.1, 13.2, 13.3, 13.5, 13.6, 13.7,
      13.9, 14.0, 14.2, 14.3, 14.5, 14.6, 14.7, 14.9, 15.0, 15.1, 15.3, 15.4,
      15.6, 15.7, 15.8, 16.0, 16.1, 16.3, 16.4, 16.5, 16.7, 16.8, 17.0, 17.1,
      17.3, 17.5, 17.6, 17.8, 18.0, 18.1, 18.3, 18.5, 18.7, 18.8, 19.0, 19.2,
      19.4, 19.6, 19.8, 20.0, 20.2, 20.4, 20.6, 20.8, 21.0, 21.2, 21.4, 21.7,
      21.9,
    ],
    sd3: [
      3.3, 3.4, 3.5, 3.6, 3.7, 3.8, 3.9, 4.0, 4.2, 4.3, 4.4, 4.5, 4.7, 4.8, 5.0,
      5.1, 5.3, 5.4, 5.6, 5.8, 6.0, 6.1, 6.3, 6.5, 6.7, 6.9, 7.1, 7.2, 7.4, 7.6,
      7.8, 8.0, 8.1, 8.3, 8.5, 8.6, 8.8, 8.9, 9.1, 9.3, 9.4, 9.6, 9.7, 9.9,
      10.0, 10.2, 10.3, 10.5, 10.6, 10.8, 10.9, 11.1, 11.2, 11.3, 11.5, 11.6,
      11.8, 11.9, 12.1, 12.2, 12.3, 12.5, 12.6, 12.7, 12.8, 13.0, 13.1, 13.2,
      13.3, 13.4, 13.6, 13.7, 13.8, 13.9, 14.0, 14.2, 14.3, 14.4, 14.6, 14.7,
      14.9, 15.0, 15.2, 15.3, 15.5, 15.6, 15.8, 15.9, 16.1, 16.2, 16.4, 16.5,
      16.7, 16.8, 17.0, 17.1, 17.3, 17.4, 17.6, 17.7, 17.9, 18.0, 18.2, 18.4,
      18.5, 18.7, 18.9, 19.1, 19.2, 19.4, 19.6, 19.8, 20.0, 20.2, 20.4, 20.6,
      20.8, 21.0, 21.2, 21.5, 21.7, 21.9, 22.1, 22.4, 22.6, 22.8, 23.1, 23.3,
      23.6, 23.8, 24.1,
    ],
  },

  WeightLengthGirls25: {
    sdneg3: [
      14.4, 14.5, 14.7, 14.8, 15.0, 15.1, 15.3, 15.4, 15.6, 15.7, 15.9, 16.0,
      16.2, 16.3, 16.5, 16.6, 16.8, 16.9, 17.1, 17.3,
    ],
    sdneg2: [
      15.7, 15.8, 16.0, 16.2, 16.3, 16.5, 16.7, 16.8, 17.0, 17.2, 17.3, 17.5,
      17.7, 17.8, 18.0, 18.2, 18.4, 18.5, 18.7, 18.9,
    ],
    sdneg1: [
      17.1, 17.3, 17.5, 17.7, 17.9, 18.0, 18.2, 18.4, 18.6, 18.8, 19.0, 19.2,
      19.4, 19.6, 19.8, 19.9, 20.1, 20.3, 20.5, 20.7,
    ],
    median: [
      18.8, 19.0, 19.2, 19.4, 19.6, 19.8, 20.0, 20.2, 20.5, 20.7, 20.9, 21.1,
      21.3, 21.5, 21.7, 22.0, 22.2, 22.4, 22.6, 22.8,
    ],
    sd1: [
      20.7, 20.9, 21.2, 21.4, 21.6, 21.8, 22.1, 22.3, 22.6, 22.8, 23.0, 23.3,
      23.5, 23.8, 24.0, 24.2, 24.5, 24.7, 25.0, 25.2,
    ],
    sd2: [
      22.9, 23.1, 23.4, 23.6, 23.9, 24.2, 24.4, 24.7, 25.0, 25.2, 25.5, 25.8,
      26.1, 26.3, 26.6, 26.9, 27.2, 27.4, 27.7, 28.0,
    ],
    sd3: [
      25.4, 25.7, 26.0, 26.2, 26.5, 26.8, 27.1, 27.4, 27.8, 28.1, 28.4, 28.7,
      29.0, 29.3, 29.6, 29.9, 30.3, 30.6, 30.9, 31.2,
    ],
  },

  WeightLengthBoys25: {
    sdneg3: [
      14.5, 14.6, 14.8, 14.9, 15.0, 15.2, 15.3, 15.4, 15.6, 15.7, 15.8, 16.0,
      16.1, 16.2, 16.4, 16.5, 16.7, 16.8, 16.9, 17.1,
    ],
    sdneg2: [
      15.8, 15.9, 16.0, 16.2, 16.3, 16.5, 16.6, 16.8, 16.9, 17.1, 17.2, 17.4,
      17.5, 17.7, 17.9, 18.0, 18.2, 18.3, 18.5, 18.6,
    ],
    sdneg1: [
      17.1, 17.3, 17.5, 17.6, 17.8, 18.0, 18.1, 18.3, 18.5, 18.6, 18.8, 19.0,
      19.2, 19.3, 19.5, 19.7, 19.9, 20.0, 20.2, 20.4,
    ],
    median: [
      18.7, 18.9, 19.1, 19.2, 19.4, 19.6, 19.8, 20.0, 20.2, 20.4, 20.6, 20.8,
      21.0, 21.2, 21.4, 21.6, 21.8, 22.0, 22.2, 22.4,
    ],
    sd1: [
      20.4, 20.7, 20.9, 21.1, 21.3, 21.5, 21.7, 21.9, 22.1, 22.4, 22.6, 22.8,
      23.0, 23.3, 23.5, 23.7, 23.9, 24.1, 24.4, 24.6,
    ],
    sd2: [
      22.4, 22.7, 22.9, 23.1, 23.4, 23.6, 23.9, 24.1, 24.4, 24.6, 24.9, 25.1,
      25.4, 25.6, 25.9, 26.1, 26.4, 26.6, 26.9, 27.2,
    ],
    sd3: [
      24.7, 25.0, 25.2, 25.5, 25.8, 26.0, 26.3, 26.6, 26.9, 27.2, 27.5, 27.8,
      28.0, 28.3, 28.6, 28.9, 29.2, 29.5, 29.8, 30.1,
    ],
  }, */
  WeightMountBoys: {
    sdneg3: [
      2.4, 2.8, 3.6, 4.3, 5.0, 5.6, 6.1, 6.6, 7.0, 7.4, 7.7, 8.0, 8.3, 8.5, 8.8,
      9.0, 9.2, 9.3, 9.5, 9.7, 9.8, 9.9, 10.1, 10.2, 10.3, 10.4, 10.4, 10.6,
      10.7, 10.8, 10.9, 11.0, 11.1, 11.2, 11.4, 11.5, 11.6, 11.7, 11.8, 11.9,
      12.1, 12.2, 12.3, 12.4, 12.5, 12.7, 12.8, 12.9, 13.0, 13.2, 13.3, 13.4,
      13.5, 13.7, 13.8, 13.9, 14.1, 14.2, 14.3, 14.5, 14.6, 14.7, 14.9, 15.0,
      15.1, 15.3, 15.4, 15.5, 15.7, 15.8, 15.9, 16.1, 16.2, 16.4, 16.5, 16.6,
      16.8, 16.9, 17.1, 17.2, 17.4, 17.5, 17.7, 17.8, 18.0, 18.1, 18.3, 18.4,
      18.6, 18.7, 18.9, 19.0, 19.2, 19.3, 19.5, 19.6, 19.8, 20.0, 20.1, 20.3,
      20.4, 20.6, 20.8, 20.9, 21.1, 21.2, 21.4, 21.6, 21.7, 21.9, 22.1, 22.2,
      22.4, 22.6, 22.8, 22.9, 23.1, 23.3, 23.5, 23.6, 23.8, 24.0, 24.2, 24.4,
      24.6, 24.8, 25.0, 25.1, 25.3, 25.5, 25.8, 26.0, 26.2, 26.4, 26.6, 26.8,
      27.0, 27.3, 27.5, 27.7, 28.0, 28.2, 28.5, 28.7, 29.0, 29.2, 29.5, 29.7,
      30.0, 30.3, 30.6, 30.8, 31.1, 31.4, 31.7, 32.0, 32.3, 32.7, 33.0, 33.3,
      33.6, 33.9, 34.3, 34.6, 35.0, 35.3, 35.6, 36.0, 36.4, 36.7, 37.1, 37.4,
      37.8, 38.2, 38.5, 38.9, 39.3, 39.7, 40.0, 40.4, 40.8, 41.1, 41.5, 41.9,
      42.3, 42.6, 43.0, 43.4, 43.7, 44.1, 44.4, 44.8, 45.1, 45.5, 45.8, 46.1,
      46.4, 46.8, 47.1, 47.4, 47.7, 48.0, 48.2, 48.5, 48.8, 49.0, 49.3, 49.5,
      49.8, 50.0, 50.2, 50.4, 50.6, 50.8, 51.0, 51.2, 51.4, 51.5, 51.7, 51.8,
      52.0, 52.1, 52.3, 52.4, 52.5, 52.7, 52.8, 52.9, 53.0, 53.1, 53.2, 53.3,
      53.4, 53.5, 53.6, 53.7, 53.7, 53.8, 53.9, 53.9, 54.0, 54.0, 54.0,
    ],
    sdneg2: [
      2.5, 3.0, 3.8, 4.5, 5.2, 5.7, 6.3, 6.7, 7.2, 7.6, 7.9, 8.2, 8.5, 8.8, 9.0,
      9.2, 9.4, 9.6, 9.7, 9.9, 10.1, 10.2, 10.3, 10.5, 10.6, 10.6, 10.7, 10.8,
      10.9, 11.1, 11.2, 11.3, 11.4, 11.5, 11.6, 11.7, 11.9, 12.0, 12.1, 12.2,
      12.3, 12.5, 12.6, 12.7, 12.8, 13.0, 13.1, 13.2, 13.3, 13.5, 13.6, 13.7,
      13.9, 14.0, 14.1, 14.3, 14.4, 14.5, 14.7, 14.8, 15.0, 15.1, 15.2, 15.4,
      15.5, 15.7, 15.8, 15.9, 16.1, 16.2, 16.4, 16.5, 16.6, 16.8, 16.9, 17.1,
      17.2, 17.4, 17.5, 17.7, 17.8, 18.0, 18.1, 18.3, 18.4, 18.6, 18.7, 18.9,
      19.1, 19.2, 19.4, 19.5, 19.7, 19.8, 20.0, 20.2, 20.3, 20.5, 20.7, 20.8,
      21.0, 21.2, 21.3, 21.5, 21.7, 21.8, 22.0, 22.2, 22.4, 22.5, 22.7, 22.9,
      23.1, 23.2, 23.4, 23.6, 23.8, 24.0, 24.2, 24.4, 24.6, 24.7, 24.9, 25.1,
      25.3, 25.5, 25.8, 26.0, 26.2, 26.4, 26.6, 26.8, 27.0, 27.3, 27.5, 27.7,
      28.0, 28.2, 28.5, 28.7, 29.0, 29.2, 29.5, 29.7, 30.0, 30.3, 30.6, 30.8,
      31.1, 31.4, 31.7, 32.0, 32.3, 32.6, 32.9, 33.2, 33.6, 33.9, 34.2, 34.6,
      34.9, 35.2, 35.6, 35.9, 36.3, 36.6, 37.0, 37.4, 37.7, 38.1, 38.5, 38.8,
      39.2, 39.6, 40.0, 40.4, 40.7, 41.1, 41.5, 41.9, 42.3, 42.6, 43.0, 43.4,
      43.8, 44.1, 44.5, 44.9, 45.2, 45.6, 45.9, 46.3, 46.6, 47.0, 47.3, 47.6,
      48.0, 48.3, 48.6, 48.9, 49.2, 49.5, 49.8, 50.0, 50.3, 50.6, 50.8, 51.1,
      51.3, 51.5, 51.7, 51.9, 52.1, 52.3, 52.5, 52.7, 52.9, 53.1, 53.2, 53.4,
      53.5, 53.7, 53.8, 54.0, 54.1, 54.2, 54.3, 54.5, 54.6, 54.7, 54.8, 54.9,
      55.0, 55.1, 55.2, 55.3, 55.4, 55.4, 55.5, 55.6, 55.6, 55.6, 55.7,
    ],
    median: [
      3.5, 4.0, 4.9, 5.7, 6.4, 7.0, 7.6, 8.2, 8.6, 9.1, 9.5, 9.8, 10.2, 10.5,
      10.7, 11.0, 11.2, 11.4, 11.6, 11.8, 12.0, 12.1, 12.3, 12.5, 12.6, 12.7,
      12.7, 12.9, 13.0, 13.2, 13.3, 13.4, 13.6, 13.7, 13.8, 14.0, 14.1, 14.3,
      14.4, 14.5, 14.7, 14.9, 15.0, 15.2, 15.3, 15.5, 15.6, 15.8, 16.0, 16.1,
      16.3, 16.5, 16.7, 16.8, 17.0, 17.2, 17.4, 17.6, 17.7, 17.9, 18.1, 18.3,
      18.5, 18.7, 18.9, 19.1, 19.2, 19.4, 19.6, 19.8, 20.0, 20.2, 20.4, 20.6,
      20.8, 21.0, 21.2, 21.4, 21.6, 21.8, 22.0, 22.2, 22.4, 22.6, 22.8, 23.0,
      23.2, 23.4, 23.6, 23.8, 24.0, 24.2, 24.4, 24.6, 24.9, 25.1, 25.3, 25.5,
      25.8, 26.0, 26.2, 26.4, 26.7, 26.9, 27.2, 27.4, 27.7, 27.9, 28.2, 28.4,
      28.7, 28.9, 29.2, 29.5, 29.8, 30.0, 30.3, 30.6, 30.9, 31.2, 31.5, 31.8,
      32.1, 32.4, 32.7, 33.0, 33.3, 33.7, 34.0, 34.3, 34.7, 35.0, 35.4, 35.7,
      36.1, 36.4, 36.8, 37.2, 37.5, 37.9, 38.3, 38.7, 39.1, 39.5, 39.9, 40.3,
      40.7, 41.1, 41.5, 41.9, 42.3, 42.8, 43.2, 43.6, 44.1, 44.5, 44.9, 45.4,
      45.8, 46.3, 46.7, 47.2, 47.6, 48.1, 48.5, 49.0, 49.4, 49.9, 50.3, 50.8,
      51.2, 51.7, 52.1, 52.6, 53.0, 53.5, 53.9, 54.4, 54.8, 55.2, 55.6, 56.1,
      56.5, 56.9, 57.3, 57.7, 58.1, 58.5, 58.9, 59.3, 59.7, 60.0, 60.4, 60.7,
      61.1, 61.4, 61.8, 62.1, 62.4, 62.7, 63.0, 63.3, 63.6, 63.9, 64.2, 64.4,
      64.7, 65.0, 65.2, 65.4, 65.7, 65.9, 66.1, 66.3, 66.5, 66.7, 66.9, 67.1,
      67.3, 67.5, 67.6, 67.8, 68.0, 68.1, 68.3, 68.5, 68.6, 68.8, 68.9, 69.1,
      69.2, 69.3, 69.5, 69.6, 69.7, 69.9, 70.0, 70.1, 70.2, 70.4, 70.5, 70.6,
      70.6,
    ],
    sd2: [
      4.3, 4.9, 6.0, 6.9, 7.8, 8.6, 9.3, 9.9, 10.5, 11.0, 11.4, 11.8, 12.2,
      12.6, 12.9, 13.2, 13.4, 13.7, 13.9, 14.1, 14.3, 14.5, 14.7, 14.9, 15.1,
      15.2, 15.3, 15.5, 15.6, 15.8, 16.0, 16.2, 16.3, 16.5, 16.7, 16.9, 17.1,
      17.3, 17.5, 17.7, 17.9, 18.1, 18.4, 18.6, 18.8, 19.1, 19.3, 19.5, 19.8,
      20.0, 20.3, 20.5, 20.8, 21.1, 21.3, 21.6, 21.9, 22.1, 22.4, 22.7, 22.9,
      23.2, 23.5, 23.8, 24.1, 24.4, 24.7, 24.9, 25.2, 25.5, 25.8, 26.1, 26.4,
      26.7, 27.0, 27.3, 27.7, 28.0, 28.3, 28.6, 28.9, 29.2, 29.6, 29.9, 30.2,
      30.6, 30.9, 31.2, 31.6, 31.9, 32.3, 32.7, 33.0, 33.4, 33.8, 34.1, 34.5,
      34.9, 35.3, 35.7, 36.1, 36.5, 36.9, 37.3, 37.7, 38.2, 38.6, 39.0, 39.5,
      39.9, 40.4, 40.8, 41.3, 41.7, 42.2, 42.7, 43.2, 43.7, 44.1, 44.6, 45.1,
      45.6, 46.2, 46.7, 47.2, 47.7, 48.2, 48.8, 49.3, 49.8, 50.4, 50.9, 51.5,
      52.0, 52.6, 53.1, 53.7, 54.2, 54.8, 55.3, 55.9, 56.5, 57.0, 57.6, 58.2,
      58.7, 59.3, 59.9, 60.4, 61.0, 61.6, 62.1, 62.7, 63.3, 63.8, 64.4, 65.0,
      65.5, 66.1, 66.7, 67.2, 67.8, 68.3, 68.9, 69.4, 70.0, 70.5, 71.1, 71.6,
      72.2, 72.7, 73.2, 73.7, 74.3, 74.8, 75.3, 75.8, 76.3, 76.8, 77.3, 77.8,
      78.3, 78.8, 79.3, 79.8, 80.3, 80.7, 81.2, 81.7, 82.1, 82.6, 83.0, 83.4,
      83.9, 84.3, 84.7, 85.1, 85.5, 85.9, 86.3, 86.7, 87.1, 87.4, 87.8, 88.1,
      88.5, 88.8, 89.1, 89.4, 89.7, 90.0, 90.3, 90.6, 90.9, 91.1, 91.4, 91.6,
      91.8, 92.0, 92.3, 92.5, 92.7, 92.8, 93.0, 93.2, 93.3, 93.5, 93.6, 93.8,
      93.9, 94.1, 94.2, 94.3, 94.4, 94.6, 94.7, 94.8, 95.0, 95.1, 95.3, 95.4,
      95.6, 95.7,
    ],
    sd3: [
      4.4, 5.0, 6.1, 7.1, 8.0, 8.8, 9.5, 10.2, 10.7, 11.3, 11.7, 12.2, 12.6,
      12.9, 13.2, 13.5, 13.8, 14.1, 14.3, 14.5, 14.7, 14.9, 15.1, 15.3, 15.5,
      15.6, 15.7, 15.9, 16.1, 16.2, 16.4, 16.6, 16.8, 17.0, 17.2, 17.4, 17.6,
      17.8, 18.0, 18.3, 18.5, 18.7, 19.0, 19.2, 19.5, 19.7, 20.0, 20.2, 20.5,
      20.7, 21.0, 21.3, 21.6, 21.8, 22.1, 22.4, 22.7, 23.0, 23.3, 23.6, 23.9,
      24.2, 24.5, 24.8, 25.1, 25.4, 25.7, 26.0, 26.3, 26.6, 27.0, 27.3, 27.6,
      27.9, 28.3, 28.6, 28.9, 29.3, 29.6, 30.0, 30.3, 30.7, 31.0, 31.4, 31.8,
      32.1, 32.5, 32.9, 33.3, 33.7, 34.1, 34.5, 34.9, 35.3, 35.7, 36.1, 36.6,
      37.0, 37.4, 37.9, 38.3, 38.8, 39.2, 39.7, 40.1, 40.6, 41.1, 41.6, 42.1,
      42.6, 43.1, 43.6, 44.1, 44.6, 45.1, 45.6, 46.2, 46.7, 47.2, 47.8, 48.3,
      48.9, 49.4, 50.0, 50.5, 51.1, 51.7, 52.2, 52.8, 53.4, 53.9, 54.5, 55.1,
      55.7, 56.3, 56.8, 57.4, 58.0, 58.6, 59.2, 59.8, 60.4, 61.0, 61.5, 62.1,
      62.7, 63.3, 63.9, 64.5, 65.1, 65.7, 66.2, 66.8, 67.4, 68.0, 68.6, 69.1,
      69.7, 70.3, 70.8, 71.4, 72.0, 72.5, 73.1, 73.7, 74.2, 74.8, 75.3, 75.9,
      76.4, 77.0, 77.5, 78.0, 78.6, 79.1, 79.6, 80.2, 80.7, 81.2, 81.7, 82.2,
      82.7, 83.2, 83.7, 84.2, 84.7, 85.2, 85.7, 86.2, 86.7, 87.1, 87.6, 88.1,
      88.5, 89.0, 89.4, 89.8, 90.3, 90.7, 91.1, 91.5, 91.9, 92.3, 92.7, 93.1,
      93.4, 93.8, 94.1, 94.5, 94.8, 95.1, 95.4, 95.7, 96.0, 96.3, 96.5, 96.8,
      97.0, 97.2, 97.5, 97.7, 97.9, 98.0, 98.2, 98.4, 98.5, 98.7, 98.8, 98.9,
      99.1, 99.2, 99.3, 99.4, 99.5, 99.6, 99.8, 99.9, 100.0, 100.1, 100.3,
      100.5, 100.7, 100.8,
    ],
  },
  WeightMountGirls: {
    sdneg3: [
      2.4, 2.8, 3.4, 4.0, 4.5, 5.1, 5.5, 6.0, 6.4, 6.7, 7.1, 7.4, 7.7, 7.9, 8.2,
      8.4, 8.6, 8.8, 9.0, 9.2, 9.3, 9.5, 9.6, 9.8, 9.9, 10.0, 10.0, 10.2, 10.3,
      10.4, 10.5, 10.6, 10.7, 10.8, 11.0, 11.1, 11.2, 11.3, 11.4, 11.5, 11.6,
      11.7, 11.8, 11.9, 12.1, 12.2, 12.3, 12.4, 12.5, 12.7, 12.8, 12.9, 13.0,
      13.2, 13.3, 13.4, 13.5, 13.7, 13.8, 13.9, 14.1, 14.2, 14.3, 14.5, 14.6,
      14.8, 14.9, 15.0, 15.2, 15.3, 15.4, 15.6, 15.7, 15.9, 16.0, 16.2, 16.3,
      16.4, 16.6, 16.7, 16.9, 17.0, 17.1, 17.3, 17.4, 17.6, 17.7, 17.9, 18.0,
      18.2, 18.3, 18.5, 18.6, 18.8, 18.9, 19.1, 19.2, 19.4, 19.5, 19.7, 19.9,
      20.0, 20.2, 20.4, 20.5, 20.7, 20.9, 21.0, 21.2, 21.4, 21.6, 21.8, 22.0,
      22.2, 22.3, 22.5, 22.7, 22.9, 23.1, 23.4, 23.6, 23.8, 24.0, 24.2, 24.4,
      24.7, 24.9, 25.1, 25.4, 25.6, 25.8, 26.1, 26.3, 26.6, 26.8, 27.1, 27.3,
      27.6, 27.9, 28.1, 28.4, 28.6, 28.9, 29.2, 29.5, 29.7, 30.0, 30.3, 30.6,
      30.9, 31.1, 31.4, 31.7, 32.0, 32.3, 32.6, 32.8, 33.1, 33.4, 33.7, 34.0,
      34.3, 34.5, 34.8, 35.1, 35.4, 35.6, 35.9, 36.2, 36.4, 36.7, 37.0, 37.2,
      37.5, 37.7, 38.0, 38.2, 38.5, 38.7, 38.9, 39.1, 39.4, 39.6, 39.8, 40.0,
      40.2, 40.4, 40.6, 40.8, 41.0, 41.2, 41.3, 41.5, 41.7, 41.8, 42.0, 42.1,
      42.3, 42.4, 42.5, 42.7, 42.8, 42.9, 43.0, 43.1, 43.2, 43.3, 43.4, 43.5,
      43.6, 43.7, 43.8, 43.9, 43.9, 44.0, 44.1, 44.1, 44.2, 44.2, 44.3, 44.4,
      44.4, 44.5, 44.5, 44.6, 44.6, 44.6, 44.7, 44.7, 44.8, 44.8, 44.8, 44.9,
      44.9, 44.9, 44.9, 45.0, 45.0, 45.0, 45.0, 45.0, 45.0, 45.0,
    ],
    sdneg2: [
      2.5, 2.9, 3.5, 4.2, 4.7, 5.2, 5.7, 6.1, 6.5, 6.9, 7.2, 7.6, 7.9, 8.1, 8.4,
      8.6, 8.8, 9.0, 9.2, 9.4, 9.6, 9.7, 9.9, 10.0, 10.1, 10.2, 10.3, 10.4,
      10.5, 10.6, 10.8, 10.9, 11.0, 11.1, 11.2, 11.3, 11.4, 11.5, 11.7, 11.8,
      11.9, 12.0, 12.1, 12.2, 12.3, 12.5, 12.6, 12.7, 12.8, 13.0, 13.1, 13.2,
      13.3, 13.5, 13.6, 13.7, 13.9, 14.0, 14.2, 14.3, 14.4, 14.6, 14.7, 14.9,
      15.0, 15.1, 15.3, 15.4, 15.6, 15.7, 15.9, 16.0, 16.1, 16.3, 16.4, 16.6,
      16.7, 16.9, 17.0, 17.2, 17.3, 17.5, 17.6, 17.8, 17.9, 18.1, 18.2, 18.4,
      18.5, 18.7, 18.8, 19.0, 19.2, 19.3, 19.5, 19.6, 19.8, 20.0, 20.1, 20.3,
      20.5, 20.7, 20.8, 21.0, 21.2, 21.4, 21.6, 21.7, 21.9, 22.1, 22.3, 22.5,
      22.7, 22.9, 23.1, 23.3, 23.5, 23.8, 24.0, 24.2, 24.4, 24.6, 24.9, 25.1,
      25.3, 25.6, 25.8, 26.1, 26.3, 26.5, 26.8, 27.1, 27.3, 27.6, 27.8, 28.1,
      28.4, 28.6, 28.9, 29.2, 29.5, 29.7, 30.0, 30.3, 30.6, 30.9, 31.2, 31.4,
      31.7, 32.0, 32.3, 32.6, 32.9, 33.2, 33.5, 33.7, 34.0, 34.3, 34.6, 34.9,
      35.2, 35.5, 35.7, 36.0, 36.3, 36.6, 36.8, 37.1, 37.4, 37.7, 37.9, 38.2,
      38.4, 38.7, 38.9, 39.2, 39.4, 39.7, 39.9, 40.1, 40.3, 40.6, 40.8, 41.0,
      41.2, 41.4, 41.6, 41.8, 42.0, 42.1, 42.3, 42.5, 42.6, 42.8, 43.0, 43.1,
      43.3, 43.4, 43.5, 43.7, 43.8, 43.9, 44.0, 44.1, 44.2, 44.3, 44.4, 44.5,
      44.6, 44.7, 44.8, 44.9, 45.0, 45.0, 45.1, 45.2, 45.2, 45.3, 45.4, 45.4,
      45.5, 45.5, 45.6, 45.6, 45.7, 45.7, 45.8, 45.8, 45.9, 45.9, 46.0, 46.0,
      46.1, 46.1, 46.1, 46.2, 46.2, 46.2, 46.2, 46.3, 46.3, 46.3, 46.3,
    ],
    median: [
      3.4, 3.8, 4.5, 5.2, 5.9, 6.4, 7.0, 7.5, 7.9, 8.3, 8.7, 9.0, 9.4, 9.7, 9.9,
      10.2, 10.4, 10.7, 10.9, 11.1, 11.3, 11.5, 11.6, 11.8, 12.0, 12.1, 12.1,
      12.3, 12.4, 12.6, 12.7, 12.9, 13.0, 13.2, 13.3, 13.5, 13.6, 13.8, 13.9,
      14.1, 14.2, 14.4, 14.6, 14.7, 14.9, 15.0, 15.2, 15.4, 15.5, 15.7, 15.9,
      16.0, 16.2, 16.4, 16.6, 16.7, 16.9, 17.1, 17.3, 17.5, 17.7, 17.8, 18.0,
      18.2, 18.4, 18.6, 18.8, 19.0, 19.2, 19.4, 19.5, 19.7, 19.9, 20.1, 20.3,
      20.5, 20.7, 20.9, 21.2, 21.4, 21.6, 21.8, 22.0, 22.2, 22.4, 22.6, 22.9,
      23.1, 23.3, 23.6, 23.8, 24.0, 24.3, 24.5, 24.7, 25.0, 25.2, 25.5, 25.8,
      26.0, 26.3, 26.6, 26.8, 27.1, 27.4, 27.7, 28.0, 28.2, 28.5, 28.8, 29.1,
      29.4, 29.8, 30.1, 30.4, 30.7, 31.0, 31.4, 31.7, 32.0, 32.4, 32.7, 33.1,
      33.4, 33.8, 34.1, 34.5, 34.8, 35.2, 35.6, 35.9, 36.3, 36.7, 37.0, 37.4,
      37.8, 38.1, 38.5, 38.9, 39.2, 39.6, 40.0, 40.4, 40.7, 41.1, 41.5, 41.8,
      42.2, 42.6, 42.9, 43.3, 43.6, 44.0, 44.3, 44.7, 45.0, 45.3, 45.7, 46.0,
      46.3, 46.6, 46.9, 47.2, 47.5, 47.8, 48.1, 48.4, 48.7, 49.0, 49.2, 49.5,
      49.7, 50.0, 50.2, 50.5, 50.7, 50.9, 51.1, 51.4, 51.6, 51.8, 51.9, 52.1,
      52.3, 52.5, 52.7, 52.8, 53.0, 53.1, 53.3, 53.4, 53.6, 53.7, 53.8, 53.9,
      54.1, 54.2, 54.3, 54.4, 54.5, 54.6, 54.7, 54.8, 54.9, 55.0, 55.1, 55.2,
      55.3, 55.4, 55.4, 55.5, 55.6, 55.7, 55.8, 55.9, 56.0, 56.1, 56.1, 56.2,
      56.3, 56.4, 56.5, 56.6, 56.7, 56.8, 56.9, 57.0, 57.1, 57.2, 57.3, 57.4,
      57.4, 57.5, 57.6, 57.7, 57.8, 57.9, 58.0, 58.0, 58.1, 58.2, 58.2, 58.2,
    ],
    sd2: [
      4.2, 4.6, 5.5, 6.3, 7.1, 7.8, 8.4, 9.0, 9.5, 10.0, 10.4, 10.8, 11.2, 11.6,
      11.9, 12.2, 12.5, 12.8, 13.0, 13.3, 13.5, 13.8, 14.0, 14.2, 14.5, 14.6,
      14.7, 14.9, 15.1, 15.3, 15.6, 15.8, 16.0, 16.2, 16.4, 16.7, 16.9, 17.1,
      17.4, 17.6, 17.8, 18.1, 18.3, 18.6, 18.8, 19.1, 19.3, 19.6, 19.9, 20.1,
      20.4, 20.7, 20.9, 21.2, 21.5, 21.8, 22.0, 22.3, 22.6, 22.9, 23.2, 23.5,
      23.8, 24.0, 24.3, 24.6, 24.9, 25.2, 25.5, 25.8, 26.1, 26.5, 26.8, 27.1,
      27.4, 27.7, 28.0, 28.4, 28.7, 29.0, 29.4, 29.7, 30.0, 30.4, 30.8, 31.1,
      31.5, 31.8, 32.2, 32.6, 33.0, 33.4, 33.8, 34.1, 34.6, 35.0, 35.4, 35.8,
      36.2, 36.7, 37.1, 37.5, 38.0, 38.5, 38.9, 39.4, 39.9, 40.3, 40.8, 41.3,
      41.8, 42.3, 42.8, 43.3, 43.9, 44.4, 44.9, 45.4, 46.0, 46.5, 47.1, 47.6,
      48.2, 48.7, 49.3, 49.8, 50.4, 51.0, 51.5, 52.1, 52.7, 53.2, 53.8, 54.4,
      55.0, 55.5, 56.1, 56.7, 57.2, 57.8, 58.3, 58.9, 59.5, 60.0, 60.5, 61.1,
      61.6, 62.2, 62.7, 63.2, 63.7, 64.2, 64.7, 65.2, 65.7, 66.2, 66.7, 67.1,
      67.6, 68.0, 68.5, 68.9, 69.3, 69.8, 70.2, 70.6, 70.9, 71.3, 71.7, 72.0,
      72.4, 72.7, 73.1, 73.4, 73.7, 74.0, 74.3, 74.6, 74.8, 75.1, 75.3, 75.6,
      75.8, 76.1, 76.3, 76.5, 76.7, 76.9, 77.1, 77.2, 77.4, 77.6, 77.7, 77.9,
      78.1, 78.2, 78.3, 78.5, 78.6, 78.7, 78.8, 79.0, 79.1, 79.2, 79.3, 79.4,
      79.5, 79.6, 79.7, 79.8, 79.9, 80.0, 80.1, 80.2, 80.3, 80.4, 80.5, 80.6,
      80.8, 80.9, 81.0, 81.1, 81.2, 81.3, 81.4, 81.5, 81.6, 81.7, 81.8, 81.9,
      82.0, 82.1, 82.2, 82.3, 82.4, 82.5, 82.6, 82.7, 82.7, 82.8, 82.9, 82.9,
      83.0,
    ],
    sd3: [
      4.3, 4.7, 5.7, 6.5, 7.3, 8.0, 8.6, 9.2, 9.7, 10.2, 10.7, 11.1, 11.5, 11.9,
      12.2, 12.5, 12.8, 13.1, 13.4, 13.7, 13.9, 14.2, 14.4, 14.6, 14.9, 15.0,
      15.1, 15.4, 15.6, 15.8, 16.0, 16.3, 16.5, 16.8, 17.0, 17.2, 17.5, 17.7,
      18.0, 18.3, 18.5, 18.8, 19.0, 19.3, 19.6, 19.9, 20.1, 20.4, 20.7, 21.0,
      21.3, 21.6, 21.9, 22.2, 22.5, 22.8, 23.1, 23.4, 23.7, 24.0, 24.3, 24.6,
      24.9, 25.3, 25.6, 25.9, 26.2, 26.6, 26.9, 27.2, 27.6, 27.9, 28.2, 28.6,
      28.9, 29.3, 29.6, 30.0, 30.3, 30.7, 31.1, 31.4, 31.8, 32.2, 32.6, 33.0,
      33.4, 33.8, 34.2, 34.6, 35.0, 35.4, 35.8, 36.3, 36.7, 37.2, 37.6, 38.1,
      38.5, 39.0, 39.5, 40.0, 40.5, 40.9, 41.4, 42.0, 42.5, 43.0, 43.5, 44.0,
      44.6, 45.1, 45.7, 46.2, 46.8, 47.4, 47.9, 48.5, 49.1, 49.7, 50.2, 50.8,
      51.4, 52.0, 52.6, 53.2, 53.8, 54.4, 55.1, 55.7, 56.3, 56.9, 57.5, 58.1,
      58.7, 59.3, 59.9, 60.5, 61.2, 61.8, 62.4, 63.0, 63.6, 64.1, 64.7, 65.3,
      65.9, 66.5, 67.0, 67.6, 68.2, 68.7, 69.3, 69.8, 70.3, 70.9, 71.4, 71.9,
      72.4, 72.9, 73.4, 73.8, 74.3, 74.7, 75.2, 75.6, 76.1, 76.5, 76.9, 77.3,
      77.7, 78.1, 78.4, 78.8, 79.2, 79.5, 79.8, 80.2, 80.5, 80.8, 81.1, 81.4,
      81.6, 81.9, 82.2, 82.4, 82.7, 82.9, 83.1, 83.4, 83.6, 83.8, 84.0, 84.2,
      84.4, 84.5, 84.7, 84.9, 85.0, 85.2, 85.4, 85.5, 85.6, 85.8, 85.9, 86.0,
      86.2, 86.3, 86.4, 86.5, 86.6, 86.7, 86.8, 86.9, 87.1, 87.1, 87.2, 87.3,
      87.4, 87.5, 87.6, 87.7, 87.8, 87.9, 88.0, 88.0, 88.1, 88.2, 88.3, 88.3,
      88.4, 88.5, 88.6, 88.6, 88.7, 88.7, 88.8, 88.9, 88.9, 89.0, 89.0, 89.0,
      89.0,
    ],
  },

  LengthMountGirls: {
    sdneg3: [
      45.1, 47.5, 51.0, 53.6, 55.9, 57.8, 59.5, 61.1, 62.6, 64.0, 65.3, 66.5,
      67.7, 68.8, 69.8, 70.9, 71.9, 72.8, 73.7, 74.6, 75.5, 76.4, 77.2, 78.0,
      78.8, 78.4, 78.8, 79.6, 80.4, 81.1, 81.9, 82.6, 83.3, 84.0, 84.6, 85.2,
      85.8, 86.4, 86.9, 87.4, 88.0, 88.5, 89.0, 89.5, 90.0, 90.5, 91.0, 91.5,
      92.0, 92.6, 93.1, 93.6, 94.1, 94.6, 95.1, 95.7, 96.2, 96.7, 97.2, 97.8,
      98.3, 98.8, 99.4, 99.9, 100.4, 101.0, 101.5, 102.0, 102.6, 103.1, 103.6,
      104.2, 104.7, 105.2, 105.8, 106.3, 106.8, 107.3, 107.9, 108.4, 108.9,
      109.4, 109.9, 110.4, 110.9, 111.4, 111.9, 112.3, 112.8, 113.3, 113.8,
      114.2, 114.7, 115.1, 115.6, 116.0, 116.4, 116.9, 117.3, 117.7, 118.1,
      118.5, 118.9, 119.3, 119.7, 120.0, 120.4, 120.8, 121.1, 121.5, 121.9,
      122.2, 122.6, 122.9, 123.2, 123.6, 123.9, 124.3, 124.6, 124.9, 125.3,
      125.6, 126.0, 126.3, 126.7, 127.0, 127.4, 127.8, 128.2, 128.5, 129.0,
      129.4, 129.8, 130.3, 130.7, 131.2, 131.7, 132.2, 132.7, 133.3, 133.8,
      134.4, 135.0, 135.6, 136.2, 136.8, 137.4, 138.1, 138.7, 139.3, 139.9,
      140.5, 141.1, 141.7, 142.2, 142.8, 143.3, 143.8, 144.2, 144.7, 145.1,
      145.5, 145.9, 146.2, 146.6, 146.9, 147.2, 147.4, 147.7, 147.9, 148.1,
      148.3, 148.5, 148.7, 148.8, 149.0, 149.1, 149.2, 149.4, 149.5, 149.6,
      149.7, 149.7, 149.8, 149.9, 150.0, 150.0, 150.1, 150.1, 150.2, 150.3,
      150.3, 150.3, 150.4, 150.4, 150.5, 150.5, 150.5, 150.6, 150.6, 150.6,
      150.6, 150.7, 150.7, 150.7, 150.7, 150.7, 150.8, 150.8, 150.8, 150.8,
      150.8, 150.9, 150.9, 150.9, 150.9, 150.9, 150.9, 150.9, 150.9, 151.0,
      151.0, 151.0, 151.0, 151.0, 151.0, 151.0, 151.0, 151.0, 151.0,
    ],
    sdneg2: [
      45.6, 48.0, 51.5, 54.2, 56.4, 58.4, 60.2, 61.8, 63.3, 64.6, 66.0, 67.2,
      68.4, 69.5, 70.6, 71.6, 72.6, 73.6, 74.5, 75.4, 76.3, 77.2, 78.0, 78.8,
      79.6, 79.3, 79.6, 80.4, 81.2, 82.0, 82.7, 83.5, 84.2, 84.8, 85.5, 86.1,
      86.7, 87.3, 87.8, 88.3, 88.9, 89.4, 89.9, 90.4, 91.0, 91.5, 92.0, 92.5,
      93.0, 93.5, 94.0, 94.6, 95.1, 95.6, 96.1, 96.7, 97.2, 97.7, 98.2, 98.8,
      99.3, 99.9, 100.4, 100.9, 101.5, 102.0, 102.6, 103.1, 103.6, 104.2, 104.7,
      105.3, 105.8, 106.3, 106.9, 107.4, 107.9, 108.5, 109.0, 109.5, 110.0,
      110.5, 111.1, 111.6, 112.1, 112.6, 113.1, 113.5, 114.0, 114.5, 115.0,
      115.4, 115.9, 116.4, 116.8, 117.3, 117.7, 118.1, 118.5, 119.0, 119.4,
      119.8, 120.2, 120.6, 121.0, 121.4, 121.7, 122.1, 122.5, 122.9, 123.2,
      123.6, 123.9, 124.3, 124.6, 125.0, 125.3, 125.7, 126.0, 126.4, 126.7,
      127.1, 127.5, 127.8, 128.2, 128.6, 128.9, 129.3, 129.7, 130.1, 130.6,
      131.0, 131.5, 131.9, 132.4, 132.9, 133.4, 133.9, 134.5, 135.0, 135.6,
      136.2, 136.8, 137.4, 138.0, 138.6, 139.2, 139.8, 140.5, 141.1, 141.7,
      142.3, 142.8, 143.4, 143.9, 144.5, 145.0, 145.4, 145.9, 146.3, 146.7,
      147.1, 147.5, 147.8, 148.1, 148.4, 148.7, 149.0, 149.2, 149.5, 149.7,
      149.9, 150.0, 150.2, 150.4, 150.5, 150.6, 150.8, 150.9, 151.0, 151.1,
      151.2, 151.3, 151.3, 151.4, 151.5, 151.5, 151.6, 151.7, 151.7, 151.8,
      151.8, 151.9, 151.9, 151.9, 152.0, 152.0, 152.0, 152.1, 152.1, 152.1,
      152.2, 152.2, 152.2, 152.2, 152.3, 152.3, 152.3, 152.3, 152.3, 152.4,
      152.4, 152.4, 152.4, 152.4, 152.4, 152.4, 152.5, 152.5, 152.5, 152.5,
      152.5, 152.5, 152.5, 152.5, 152.5, 152.5, 152.6, 152.6, 152.6,
    ],
    median: [
      49.3, 51.7, 55.3, 58.1, 60.5, 62.5, 64.4, 66.1, 67.7, 69.2, 70.6, 71.9,
      73.2, 74.4, 75.6, 76.7, 77.8, 78.8, 79.8, 80.8, 81.8, 82.7, 83.6, 84.5,
      85.3, 85.0, 85.4, 86.3, 87.2, 88.0, 88.8, 89.6, 90.3, 91.1, 91.7, 92.4,
      93.0, 93.6, 94.2, 94.8, 95.4, 95.9, 96.5, 97.1, 97.6, 98.2, 98.8, 99.3,
      99.9, 100.5, 101.0, 101.6, 102.2, 102.7, 103.3, 103.9, 104.5, 105.0,
      105.6, 106.2, 106.8, 107.4, 108.0, 108.5, 109.1, 109.7, 110.3, 110.9,
      111.5, 112.1, 112.7, 113.3, 113.8, 114.4, 115.0, 115.6, 116.2, 116.7,
      117.3, 117.9, 118.4, 119.0, 119.6, 120.1, 120.7, 121.2, 121.8, 122.3,
      122.8, 123.4, 123.9, 124.4, 124.9, 125.4, 125.9, 126.4, 126.9, 127.4,
      127.8, 128.3, 128.8, 129.2, 129.7, 130.1, 130.6, 131.0, 131.4, 131.9,
      132.3, 132.7, 133.1, 133.5, 134.0, 134.4, 134.8, 135.2, 135.6, 136.1,
      136.5, 136.9, 137.3, 137.8, 138.2, 138.7, 139.1, 139.6, 140.1, 140.5,
      141.0, 141.5, 142.1, 142.6, 143.1, 143.7, 144.3, 144.8, 145.4, 146.0,
      146.6, 147.2, 147.8, 148.5, 149.1, 149.7, 150.3, 150.9, 151.5, 152.1,
      152.6, 153.2, 153.7, 154.3, 154.8, 155.2, 155.7, 156.1, 156.6, 157.0,
      157.3, 157.7, 158.0, 158.4, 158.7, 158.9, 159.2, 159.5, 159.7, 159.9,
      160.1, 160.3, 160.5, 160.6, 160.8, 160.9, 161.1, 161.2, 161.3, 161.4,
      161.5, 161.6, 161.7, 161.8, 161.9, 162.0, 162.0, 162.1, 162.2, 162.2,
      162.3, 162.3, 162.4, 162.4, 162.5, 162.5, 162.6, 162.6, 162.6, 162.7,
      162.7, 162.7, 162.8, 162.8, 162.8, 162.9, 162.9, 162.9, 162.9, 162.9,
      163.0, 163.0, 163.0, 163.0, 163.0, 163.1, 163.1, 163.1, 163.1, 163.1,
      163.1, 163.1, 163.2, 163.2, 163.2, 163.2, 163.2, 163.2, 163.2, 163.2,
      163.2, 163.3,
    ],
    sd1: [
      53.8, 56.0, 59.4, 62.2, 64.5, 66.6, 68.6, 70.4, 72.0, 73.6, 75.1, 76.5,
      77.8, 79.1, 80.4, 81.6, 82.8, 83.9, 85.0, 86.1, 87.1, 88.1, 89.1, 90.1,
      91.0, 90.7, 91.1, 92.1, 93.1, 94.0, 94.9, 95.8, 96.6, 97.4, 98.1, 98.8,
      99.5, 100.2, 100.8, 101.5, 102.1, 102.7, 103.4, 104.0, 104.6, 105.3,
      105.9, 106.5, 107.2, 107.8, 108.4, 109.1, 109.7, 110.3, 111.0, 111.6,
      112.2, 112.9, 113.5, 114.2, 114.8, 115.5, 116.1, 116.8, 117.4, 118.1,
      118.7, 119.4, 120.0, 120.7, 121.3, 122.0, 122.6, 123.3, 123.9, 124.5,
      125.2, 125.8, 126.4, 127.1, 127.7, 128.3, 128.9, 129.5, 130.1, 130.7,
      131.3, 131.9, 132.5, 133.0, 133.6, 134.2, 134.7, 135.3, 135.8, 136.3,
      136.9, 137.4, 137.9, 138.4, 138.9, 139.4, 139.9, 140.4, 140.9, 141.4,
      141.9, 142.3, 142.8, 143.3, 143.8, 144.2, 144.7, 145.2, 145.7, 146.1,
      146.6, 147.1, 147.6, 148.1, 148.6, 149.1, 149.6, 150.1, 150.7, 151.2,
      151.7, 152.3, 152.8, 153.4, 154.0, 154.6, 155.2, 155.8, 156.4, 157.0,
      157.6, 158.2, 158.8, 159.4, 160.0, 160.6, 161.2, 161.8, 162.4, 162.9,
      163.5, 164.0, 164.5, 165.0, 165.5, 165.9, 166.4, 166.8, 167.2, 167.6,
      167.9, 168.3, 168.6, 168.9, 169.2, 169.5, 169.7, 170.0, 170.2, 170.4,
      170.6, 170.8, 171.0, 171.2, 171.3, 171.5, 171.6, 171.7, 171.9, 172.0,
      172.1, 172.2, 172.3, 172.4, 172.5, 172.5, 172.6, 172.7, 172.7, 172.8,
      172.9, 172.9, 173.0, 173.0, 173.1, 173.1, 173.2, 173.2, 173.2, 173.3,
      173.3, 173.3, 173.4, 173.4, 173.4, 173.5, 173.5, 173.5, 173.5, 173.6,
      173.6, 173.6, 173.6, 173.6, 173.6, 173.7, 173.7, 173.7, 173.7, 173.7,
      173.7, 173.8, 173.8, 173.8, 173.8, 173.8, 173.8, 173.8, 173.8, 173.8,
      173.8, 173.9, 173.9, 173.9,
    ],
    sd2: [
      54.5, 56.6, 60.0, 62.7, 65.1, 67.2, 69.2, 71.0, 72.6, 74.2, 75.7, 77.1,
      78.5, 79.8, 81.1, 82.3, 83.5, 84.6, 85.7, 86.8, 87.9, 88.9, 89.9, 90.9,
      91.9, 91.5, 91.9, 93.0, 93.9, 94.9, 95.8, 96.6, 97.5, 98.3, 99.0, 99.8,
      100.5, 101.1, 101.8, 102.4, 103.1, 103.7, 104.4, 105.0, 105.7, 106.3,
      107.0, 107.6, 108.2, 108.9, 109.5, 110.2, 110.8, 111.5, 112.1, 112.8,
      113.4, 114.1, 114.7, 115.4, 116.0, 116.7, 117.4, 118.0, 118.7, 119.3,
      120.0, 120.7, 121.3, 122.0, 122.6, 123.3, 124.0, 124.6, 125.3, 125.9,
      126.5, 127.2, 127.8, 128.4, 129.1, 129.7, 130.3, 130.9, 131.5, 132.1,
      132.7, 133.3, 133.9, 134.5, 135.1, 135.6, 136.2, 136.7, 137.3, 137.8,
      138.4, 138.9, 139.4, 139.9, 140.4, 140.9, 141.5, 142.0, 142.4, 142.9,
      143.4, 143.9, 144.4, 144.9, 145.4, 145.8, 146.3, 146.8, 147.3, 147.8,
      148.3, 148.7, 149.2, 149.7, 150.3, 150.8, 151.3, 151.8, 152.4, 152.9,
      153.5, 154.0, 154.6, 155.2, 155.7, 156.3, 156.9, 157.5, 158.1, 158.7,
      159.3, 160.0, 160.6, 161.2, 161.8, 162.4, 162.9, 163.5, 164.1, 164.6,
      165.2, 165.7, 166.2, 166.7, 167.1, 167.6, 168.0, 168.4, 168.8, 169.2,
      169.5, 169.9, 170.2, 170.5, 170.8, 171.1, 171.3, 171.6, 171.8, 172.0,
      172.2, 172.4, 172.6, 172.7, 172.9, 173.0, 173.2, 173.3, 173.4, 173.5,
      173.6, 173.7, 173.8, 173.9, 174.0, 174.1, 174.2, 174.2, 174.3, 174.3,
      174.4, 174.5, 174.5, 174.6, 174.6, 174.7, 174.7, 174.7, 174.8, 174.8,
      174.8, 174.9, 174.9, 174.9, 175.0, 175.0, 175.0, 175.0, 175.1, 175.1,
      175.1, 175.1, 175.1, 175.2, 175.2, 175.2, 175.2, 175.2, 175.2, 175.2,
      175.3, 175.3, 175.3, 175.3, 175.3, 175.3, 175.3, 175.3, 175.3, 175.4,
      175.4, 175.4, 175.4, 175.4,
    ],
  },
  LengthMountBoys: {
    sdneg3: [
      44.9, 48.0, 52.2, 55.3, 57.7, 59.8, 61.7, 63.3, 64.8, 66.2, 67.5, 68.7,
      69.8, 70.9, 71.9, 72.9, 73.9, 74.8, 75.6, 76.5, 77.3, 78.1, 78.8, 79.6,
      80.3, 79.9, 80.3, 81.0, 81.7, 82.4, 83.1, 83.8, 84.5, 85.2, 85.8, 86.5,
      87.1, 87.8, 88.4, 88.9, 89.5, 90.0, 90.5, 91.1, 91.6, 92.1, 92.6, 93.1,
      93.6, 94.1, 94.6, 95.1, 95.6, 96.0, 96.5, 97.0, 97.5, 98.0, 98.4, 98.9,
      99.4, 99.9, 100.3, 100.8, 101.3, 101.8, 102.2, 102.7, 103.2, 103.7, 104.2,
      104.6, 105.1, 105.6, 106.1, 106.6, 107.1, 107.6, 108.1, 108.5, 109.0,
      109.5, 110.0, 110.5, 111.0, 111.5, 111.9, 112.4, 112.9, 113.4, 113.9,
      114.3, 114.8, 115.2, 115.7, 116.2, 116.6, 117.1, 117.5, 117.9, 118.4,
      118.8, 119.2, 119.6, 120.0, 120.5, 120.9, 121.2, 121.6, 122.0, 122.4,
      122.8, 123.2, 123.5, 123.9, 124.2, 124.6, 124.9, 125.3, 125.6, 126.0,
      126.3, 126.7, 127.0, 127.3, 127.7, 128.0, 128.4, 128.7, 129.0, 129.4,
      129.7, 130.1, 130.5, 130.8, 131.2, 131.5, 131.9, 132.3, 132.7, 133.1,
      133.5, 133.9, 134.3, 134.8, 135.2, 135.7, 136.1, 136.6, 137.1, 137.5,
      138.0, 138.5, 139.1, 139.6, 140.1, 140.6, 141.2, 141.7, 142.3, 142.8,
      143.4, 144.0, 144.5, 145.1, 145.7, 146.3, 146.8, 147.4, 148.0, 148.5,
      149.1, 149.6, 150.2, 150.7, 151.2, 151.8, 152.3, 152.8, 153.2, 153.7,
      154.2, 154.6, 155.0, 155.5, 155.9, 156.2, 156.6, 157.0, 157.3, 157.7,
      158.0, 158.3, 158.6, 158.8, 159.1, 159.4, 159.6, 159.8, 160.0, 160.3,
      160.4, 160.6, 160.8, 161.0, 161.1, 161.3, 161.4, 161.5, 161.7, 161.8,
      161.9, 162.0, 162.1, 162.2, 162.3, 162.4, 162.4, 162.5, 162.6, 162.6,
      162.7, 162.7, 162.8, 162.8, 162.9, 162.9, 163.0, 163.0, 163.0,
    ],
    sdneg2: [
      45.6, 48.6, 52.7, 55.8, 58.2, 60.3, 62.2, 63.8, 65.4, 66.8, 68.1, 69.3,
      70.4, 71.5, 72.6, 73.6, 74.5, 75.4, 76.3, 77.2, 78.0, 78.8, 79.6, 80.4,
      81.1, 80.7, 81.1, 81.8, 82.6, 83.3, 84.0, 84.7, 85.3, 86.0, 86.7, 87.3,
      88.0, 88.6, 89.2, 89.8, 90.3, 90.9, 91.4, 92.0, 92.5, 93.0, 93.5, 94.1,
      94.6, 95.1, 95.6, 96.1, 96.6, 97.1, 97.6, 98.1, 98.5, 99.0, 99.5, 100.0,
      100.5, 101.0, 101.5, 101.9, 102.4, 102.9, 103.4, 103.9, 104.4, 104.9,
      105.3, 105.8, 106.3, 106.8, 107.3, 107.8, 108.3, 108.8, 109.3, 109.8,
      110.3, 110.8, 111.2, 111.7, 112.2, 112.7, 113.2, 113.7, 114.2, 114.6,
      115.1, 115.6, 116.1, 116.5, 117.0, 117.5, 117.9, 118.4, 118.8, 119.2,
      119.7, 120.1, 120.5, 121.0, 121.4, 121.8, 122.2, 122.6, 123.0, 123.4,
      123.8, 124.2, 124.6, 124.9, 125.3, 125.7, 126.0, 126.4, 126.8, 127.1,
      127.5, 127.8, 128.2, 128.5, 128.9, 129.2, 129.6, 129.9, 130.2, 130.6,
      131.0, 131.3, 131.7, 132.0, 132.4, 132.8, 133.1, 133.5, 133.9, 134.3,
      134.7, 135.1, 135.6, 136.0, 136.4, 136.9, 137.3, 137.8, 138.3, 138.8,
      139.3, 139.8, 140.3, 140.8, 141.3, 141.9, 142.4, 143.0, 143.6, 144.1,
      144.7, 145.3, 145.9, 146.5, 147.0, 147.6, 148.2, 148.8, 149.4, 150.0,
      150.5, 151.1, 151.7, 152.2, 152.8, 153.3, 153.8, 154.3, 154.8, 155.3,
      155.8, 156.2, 156.7, 157.1, 157.5, 157.9, 158.3, 158.6, 159.0, 159.3,
      159.6, 159.9, 160.2, 160.5, 160.8, 161.0, 161.3, 161.5, 161.7, 161.9,
      162.1, 162.3, 162.5, 162.6, 162.8, 162.9, 163.1, 163.2, 163.3, 163.5,
      163.6, 163.7, 163.8, 163.9, 163.9, 164.0, 164.1, 164.2, 164.2, 164.3,
      164.4, 164.4, 164.5, 164.5, 164.6, 164.6, 164.7, 164.7, 164.7, 164.8,
    ],
    median: [
      50.0, 52.7, 56.6, 59.6, 62.1, 64.2, 66.1, 67.9, 69.5, 70.9, 72.3, 73.7,
      74.9, 76.1, 77.3, 78.4, 79.4, 80.5, 81.4, 82.4, 83.3, 84.2, 85.1, 86.0,
      86.8, 86.5, 86.9, 87.7, 88.4, 89.2, 89.9, 90.6, 91.3, 92.0, 92.7, 93.4,
      94.0, 94.6, 95.3, 95.9, 96.5, 97.2, 97.8, 98.4, 99.0, 99.6, 100.2, 100.8,
      101.4, 101.9, 102.5, 103.1, 103.6, 104.2, 104.8, 105.3, 105.9, 106.4,
      107.0, 107.5, 108.1, 108.6, 109.2, 109.7, 110.3, 110.8, 111.3, 111.9,
      112.4, 113.0, 113.5, 114.0, 114.6, 115.1, 115.7, 116.2, 116.7, 117.3,
      117.8, 118.3, 118.9, 119.4, 119.9, 120.5, 121.0, 121.5, 122.0, 122.6,
      123.1, 123.6, 124.1, 124.6, 125.1, 125.6, 126.1, 126.6, 127.1, 127.6,
      128.1, 128.6, 129.1, 129.6, 130.1, 130.5, 131.0, 131.5, 131.9, 132.4,
      132.8, 133.3, 133.7, 134.2, 134.6, 135.1, 135.5, 135.9, 136.3, 136.8,
      137.2, 137.6, 138.0, 138.4, 138.8, 139.2, 139.6, 140.0, 140.4, 140.9,
      141.3, 141.7, 142.1, 142.5, 142.9, 143.3, 143.7, 144.2, 144.6, 145.0,
      145.5, 145.9, 146.4, 146.8, 147.3, 147.8, 148.3, 148.8, 149.3, 149.8,
      150.4, 150.9, 151.5, 152.1, 152.7, 153.3, 153.9, 154.5, 155.1, 155.8,
      156.4, 157.1, 157.7, 158.4, 159.0, 159.7, 160.3, 161.0, 161.6, 162.3,
      162.9, 163.5, 164.1, 164.7, 165.3, 165.9, 166.4, 167.0, 167.5, 168.0,
      168.4, 168.9, 169.3, 169.7, 170.1, 170.5, 170.9, 171.2, 171.6, 171.9,
      172.2, 172.4, 172.7, 172.9, 173.2, 173.4, 173.6, 173.8, 174.0, 174.2,
      174.3, 174.5, 174.6, 174.8, 174.9, 175.0, 175.1, 175.2, 175.3, 175.4,
      175.5, 175.6, 175.7, 175.8, 175.8, 175.9, 176.0, 176.0, 176.1, 176.1,
      176.2, 176.2, 176.3, 176.3, 176.4, 176.4, 176.4, 176.5, 176.5, 176.5,
      176.6, 176.6,
    ],
    sd1: [
      54.3, 57.0, 61.0, 64.0, 66.5, 68.8, 70.8, 72.6, 74.2, 75.8, 77.3, 78.7,
      80.0, 81.2, 82.5, 83.6, 84.8, 85.8, 86.9, 87.9, 88.9, 89.9, 90.8, 91.7,
      92.6, 92.2, 92.6, 93.5, 94.4, 95.3, 96.1, 96.9, 97.7, 98.4, 99.2, 99.9,
      100.6, 101.3, 101.9, 102.6, 103.2, 103.9, 104.5, 105.2, 105.8, 106.4,
      107.1, 107.7, 108.3, 108.9, 109.5, 110.1, 110.7, 111.3, 111.9, 112.6,
      113.2, 113.8, 114.4, 115.0, 115.6, 116.2, 116.8, 117.4, 118.0, 118.6,
      119.1, 119.7, 120.3, 120.9, 121.5, 122.1, 122.7, 123.3, 123.9, 124.5,
      125.1, 125.7, 126.3, 126.9, 127.5, 128.1, 128.7, 129.3, 129.9, 130.4,
      131.0, 131.6, 132.2, 132.8, 133.3, 133.9, 134.5, 135.0, 135.6, 136.2,
      136.7, 137.3, 137.8, 138.4, 138.9, 139.5, 140.0, 140.5, 141.0, 141.6,
      142.1, 142.6, 143.1, 143.6, 144.1, 144.6, 145.1, 145.6, 146.1, 146.6,
      147.1, 147.5, 148.0, 148.5, 149.0, 149.4, 149.9, 150.4, 150.8, 151.3,
      151.8, 152.2, 152.7, 153.2, 153.6, 154.1, 154.6, 155.1, 155.5, 156.0,
      156.5, 157.0, 157.5, 158.0, 158.6, 159.1, 159.6, 160.2, 160.7, 161.3,
      161.9, 162.5, 163.1, 163.7, 164.3, 164.9, 165.5, 166.2, 166.8, 167.5,
      168.1, 168.8, 169.5, 170.1, 170.8, 171.4, 172.1, 172.8, 173.4, 174.0,
      174.7, 175.3, 175.9, 176.5, 177.0, 177.6, 178.1, 178.6, 179.1, 179.6,
      180.1, 180.5, 180.9, 181.3, 181.7, 182.1, 182.4, 182.8, 183.1, 183.4,
      183.7, 183.9, 184.2, 184.4, 184.7, 184.9, 185.1, 185.3, 185.5, 185.6,
      185.8, 185.9, 186.1, 186.2, 186.4, 186.5, 186.6, 186.7, 186.8, 186.9,
      187.0, 187.1, 187.2, 187.3, 187.3, 187.4, 187.5, 187.5, 187.6, 187.7,
      187.7, 187.8, 187.8, 187.9, 187.9, 187.9, 188.0, 188.0, 188.1, 188.1,
      188.1, 188.2, 188.2, 188.2,
    ],
    sd2: [
      54.9, 57.6, 61.6, 64.7, 67.3, 69.5, 71.5, 73.3, 75.0, 76.6, 78.0, 79.4,
      80.8, 82.0, 83.3, 84.4, 85.6, 86.6, 87.7, 88.7, 89.7, 90.7, 91.6, 92.5,
      93.4, 93.0, 93.5, 94.4, 95.3, 96.1, 97.0, 97.8, 98.6, 99.4, 100.1, 100.9,
      101.6, 102.3, 102.9, 103.6, 104.3, 104.9, 105.5, 106.2, 106.8, 107.4,
      108.1, 108.7, 109.3, 109.9, 110.5, 111.1, 111.8, 112.4, 113.0, 113.6,
      114.2, 114.8, 115.4, 116.0, 116.6, 117.2, 117.8, 118.4, 119.0, 119.6,
      120.3, 120.9, 121.5, 122.1, 122.7, 123.3, 123.9, 124.5, 125.1, 125.7,
      126.3, 126.9, 127.5, 128.1, 128.7, 129.3, 129.9, 130.5, 131.1, 131.7,
      132.3, 132.9, 133.5, 134.1, 134.7, 135.3, 135.8, 136.4, 137.0, 137.6,
      138.1, 138.7, 139.3, 139.8, 140.4, 140.9, 141.5, 142.0, 142.5, 143.1,
      143.6, 144.1, 144.6, 145.1, 145.7, 146.2, 146.7, 147.2, 147.7, 148.2,
      148.6, 149.1, 149.6, 150.1, 150.6, 151.1, 151.5, 152.0, 152.5, 153.0,
      153.4, 153.9, 154.4, 154.8, 155.3, 155.8, 156.3, 156.8, 157.3, 157.8,
      158.3, 158.8, 159.3, 159.8, 160.4, 160.9, 161.4, 162.0, 162.6, 163.1,
      163.7, 164.3, 164.9, 165.5, 166.1, 166.8, 167.4, 168.1, 168.7, 169.4,
      170.0, 170.7, 171.3, 172.0, 172.7, 173.3, 174.0, 174.6, 175.2, 175.9,
      176.5, 177.1, 177.7, 178.3, 178.8, 179.4, 179.9, 180.4, 180.9, 181.4,
      181.8, 182.2, 182.7, 183.0, 183.4, 183.8, 184.1, 184.5, 184.8, 185.1,
      185.3, 185.6, 185.8, 186.1, 186.3, 186.5, 186.7, 186.9, 187.1, 187.3,
      187.4, 187.6, 187.7, 187.9, 188.0, 188.1, 188.2, 188.3, 188.4, 188.5,
      188.6, 188.7, 188.8, 188.9, 189.0, 189.0, 189.1, 189.2, 189.2, 189.3,
      189.4, 189.4, 189.5, 189.5, 189.6, 189.6, 189.6, 189.7, 189.7, 189.8,
      189.8, 189.8, 189.9, 189.9,
    ],
  },

  WeightLengthGirls02: {
    sdneg3: [
      11.2, 12.1, 13.2, 13.8, 14.1, 14.3, 14.3, 14.4, 14.3, 14.2, 14.1, 14.0,
      13.9, 13.8, 13.7, 13.6, 13.6, 13.5, 13.4, 13.4, 13.3, 13.3, 13.2, 13.2,
      14.1, 14.1, 14.1, 14.1, 14.0, 14.0, 14.0, 14.0, 13.9, 13.9, 13.9, 13.9,
      13.8, 13.8, 13.8, 13.8, 13.7, 13.7, 13.7, 13.7, 13.6, 13.6, 13.6, 13.6,
      13.6, 13.5, 13.5, 13.5, 13.5, 13.5, 13.4, 13.4, 13.4, 13.4, 13.4, 13.4,
      13.4, 13.3, 13.3, 13.3, 13.3, 13.3, 13.3, 13.3, 13.3, 13.3, 13.3, 13.2,
      13.2, 13.2, 13.2, 13.2, 13.2, 13.2, 13.2, 13.2, 13.2, 13.2, 13.2, 13.2,
      13.2, 13.2, 13.2, 13.2, 13.2, 13.2, 13.2, 13.2, 13.3, 13.3, 13.3, 13.3,
      13.3, 13.3, 13.3, 13.3, 13.3, 13.3, 13.4, 13.4, 13.4, 13.4, 13.4, 13.4,
      13.5, 13.5, 13.5, 13.5, 13.5, 13.6, 13.6, 13.6, 13.6, 13.6, 13.7, 13.7,
      13.7, 13.7, 13.8, 13.8, 13.8, 13.8, 13.9, 13.9, 13.9, 14.0, 14.0, 14.0,
      14.1, 14.1, 14.1, 14.1, 14.2, 14.2, 14.2, 14.3, 14.3, 14.4, 14.4, 14.4,
      14.5, 14.5, 14.5, 14.6, 14.6, 14.6, 14.7, 14.7, 14.8, 14.8, 14.8, 14.9,
      14.9, 15.0, 15.0, 15.0, 15.1, 15.1, 15.2, 15.2, 15.2, 15.3, 15.3, 15.4,
      15.4, 15.4, 15.5, 15.5, 15.6, 15.6, 15.6, 15.7, 15.7, 15.8, 15.8, 15.9,
      15.9, 15.9, 16.0, 16.0, 16.1, 16.1, 16.1, 16.2, 16.2, 16.3, 16.3, 16.3,
      16.4, 16.4, 16.5, 16.5, 16.5, 16.6, 16.6, 16.6, 16.7, 16.7, 16.7, 16.8,
      16.8, 16.8, 16.9, 16.9, 16.9, 17.0, 17.0, 17.0, 17.0, 17.1, 17.1, 17.1,
      17.1, 17.2, 17.2, 17.2, 17.2, 17.3, 17.3, 17.3, 17.3, 17.3, 17.3, 17.4,
      17.4,
    ],
    sdneg2: [
      12.2, 13.2, 14.3, 14.9, 15.2, 15.4, 15.4, 15.5, 15.4, 15.3, 15.2, 15.1,
      15.0, 14.9, 14.8, 14.7, 14.6, 14.5, 14.4, 14.4, 14.3, 14.3, 14.2, 14.2,
      15.0, 15.0, 15.0, 14.9, 14.9, 14.8, 14.8, 14.8, 14.7, 14.7, 14.6, 14.6,
      14.6, 14.5, 14.5, 14.5, 14.4, 14.4, 14.4, 14.3, 14.3, 14.3, 14.3, 14.2,
      14.2, 14.2, 14.2, 14.2, 14.1, 14.1, 14.1, 14.1, 14.1, 14.1, 14.0, 14.0,
      14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0,
      14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0,
      14.0, 14.0, 14.0, 14.0, 14.1, 14.1, 14.1, 14.1, 14.1, 14.1, 14.2, 14.2,
      14.2, 14.2, 14.2, 14.2, 14.3, 14.3, 14.3, 14.3, 14.4, 14.4, 14.4, 14.4,
      14.5, 14.5, 14.5, 14.5, 14.6, 14.6, 14.6, 14.7, 14.7, 14.7, 14.8, 14.8,
      14.8, 14.9, 14.9, 14.9, 15.0, 15.0, 15.0, 15.1, 15.1, 15.1, 15.2, 15.2,
      15.3, 15.3, 15.3, 15.4, 15.4, 15.4, 15.5, 15.5, 15.6, 15.6, 15.7, 15.7,
      15.7, 15.8, 15.8, 15.9, 15.9, 15.9, 16.0, 16.0, 16.1, 16.1, 16.2, 16.2,
      16.3, 16.3, 16.3, 16.4, 16.4, 16.5, 16.5, 16.6, 16.6, 16.7, 16.7, 16.7,
      16.8, 16.8, 16.9, 16.9, 17.0, 17.0, 17.0, 17.1, 17.1, 17.2, 17.2, 17.3,
      17.3, 17.3, 17.4, 17.4, 17.5, 17.5, 17.6, 17.6, 17.6, 17.7, 17.7, 17.8,
      17.8, 17.8, 17.9, 17.9, 18.0, 18.0, 18.0, 18.1, 18.1, 18.1, 18.2, 18.2,
      18.2, 18.3, 18.3, 18.3, 18.4, 18.4, 18.4, 18.5, 18.5, 18.5, 18.5, 18.6,
      18.6, 18.6, 18.6, 18.7, 18.7, 18.7, 18.7, 18.7, 18.8, 18.8, 18.8, 18.8,
      18.8,
    ],
    sdneg1: [
      12.2, 13.2, 14.3, 14.9, 15.2, 15.4, 15.5, 15.5, 15.4, 15.3, 15.2, 15.1,
      15.0, 14.9, 14.8, 14.7, 14.6, 14.5, 14.4, 14.4, 14.3, 14.3, 14.2, 14.2,
      14.4, 14.4, 14.4, 14.4, 14.3, 14.3, 14.3, 14.3, 14.3, 14.2, 14.2, 14.2,
      14.2, 14.1, 14.1, 14.1, 14.1, 14.1, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0,
      14.0, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9,
      13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9,
      13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9, 13.9,
      13.9, 13.9, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.1, 14.1, 14.1,
      14.1, 14.1, 14.2, 14.2, 14.2, 14.2, 14.3, 14.3, 14.3, 14.3, 14.4, 14.4,
      14.4, 14.5, 14.5, 14.5, 14.6, 14.6, 14.6, 14.7, 14.7, 14.7, 14.8, 14.8,
      14.8, 14.9, 14.9, 14.9, 15.0, 15.0, 15.1, 15.1, 15.2, 15.2, 15.3, 15.3,
      15.3, 15.4, 15.4, 15.5, 15.5, 15.6, 15.6, 15.7, 15.7, 15.8, 15.8, 15.9,
      16.0, 16.0, 16.1, 16.1, 16.2, 16.2, 16.3, 16.3, 16.4, 16.4, 16.5, 16.6,
      16.6, 16.7, 16.7, 16.8, 16.8, 16.9, 16.9, 17.0, 17.0, 17.1, 17.1, 17.2,
      17.2, 17.3, 17.3, 17.4, 17.4, 17.5, 17.5, 17.6, 17.6, 17.6, 17.7, 17.7,
      17.8, 17.8, 17.8, 17.9, 17.9, 17.9, 18.0, 18.0, 18.0, 18.1, 18.1, 18.1,
      18.2, 18.2, 18.2, 18.2, 18.3, 18.3, 18.3, 18.3, 18.3, 18.4, 18.4, 18.4,
      18.4, 18.4, 18.4, 18.5, 18.5, 18.5, 18.5, 18.5, 18.5, 18.5, 18.5, 18.6,
      18.6, 18.6, 18.6, 18.6, 18.6, 18.6, 18.6, 18.6, 18.6, 18.7, 18.7, 18.7,
      18.7,
    ],
    median: [
      13.3, 14.6, 15.8, 16.4, 16.7, 16.8, 16.9, 16.9, 16.8, 16.7, 16.6, 16.5,
      16.4, 16.2, 16.1, 16.0, 15.9, 15.8, 15.7, 15.7, 15.6, 15.5, 15.5, 15.4,
      16.4, 16.4, 16.3, 16.3, 16.2, 16.1, 16.1, 16.0, 15.9, 15.9, 15.8, 15.8,
      15.7, 15.7, 15.7, 15.6, 15.6, 15.5, 15.5, 15.5, 15.4, 15.4, 15.4, 15.3,
      15.3, 15.3, 15.3, 15.3, 15.2, 15.2, 15.2, 15.2, 15.2, 15.2, 15.2, 15.2,
      15.2, 15.2, 15.1, 15.1, 15.1, 15.2, 15.2, 15.2, 15.2, 15.2, 15.2, 15.2,
      15.2, 15.2, 15.2, 15.2, 15.3, 15.3, 15.3, 15.3, 15.3, 15.4, 15.4, 15.4,
      15.4, 15.5, 15.5, 15.5, 15.5, 15.6, 15.6, 15.6, 15.7, 15.7, 15.7, 15.8,
      15.8, 15.8, 15.9, 15.9, 15.9, 16.0, 16.0, 16.1, 16.1, 16.1, 16.2, 16.2,
      16.3, 16.3, 16.3, 16.4, 16.4, 16.5, 16.5, 16.6, 16.6, 16.7, 16.7, 16.8,
      16.8, 16.9, 16.9, 17.0, 17.0, 17.1, 17.1, 17.2, 17.2, 17.3, 17.3, 17.4,
      17.4, 17.5, 17.5, 17.6, 17.6, 17.7, 17.7, 17.8, 17.8, 17.9, 17.9, 18.0,
      18.0, 18.1, 18.2, 18.2, 18.3, 18.3, 18.4, 18.4, 18.5, 18.5, 18.6, 18.6,
      18.7, 18.7, 18.8, 18.8, 18.9, 18.9, 19.0, 19.0, 19.1, 19.2, 19.2, 19.3,
      19.3, 19.4, 19.4, 19.5, 19.5, 19.6, 19.6, 19.6, 19.7, 19.7, 19.8, 19.8,
      19.9, 19.9, 20.0, 20.0, 20.1, 20.1, 20.2, 20.2, 20.2, 20.3, 20.3, 20.4,
      20.4, 20.5, 20.5, 20.5, 20.6, 20.6, 20.7, 20.7, 20.7, 20.8, 20.8, 20.8,
      20.9, 20.9, 20.9, 21.0, 21.0, 21.0, 21.1, 21.1, 21.1, 21.2, 21.2, 21.2,
      21.2, 21.3, 21.3, 21.3, 21.4, 21.4, 21.4, 21.4, 21.4, 21.5, 21.5, 21.5,
      21.5,
    ],
    sd1: [
      14.6, 16.0, 17.3, 17.9, 18.3, 18.4, 18.5, 18.5, 18.4, 18.3, 18.2, 18.0,
      17.9, 17.7, 17.6, 17.5, 17.4, 17.3, 17.2, 17.1, 17.0, 17.0, 16.9, 16.9,
      17.1, 17.1, 17.0, 17.0, 17.0, 17.0, 16.9, 16.9, 16.9, 16.9, 16.8, 16.8,
      16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8,
      16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.9, 16.9, 16.9,
      16.9, 16.9, 16.9, 16.9, 16.9, 16.9, 16.9, 16.9, 17.0, 17.0, 17.0, 17.0,
      17.0, 17.0, 17.0, 17.1, 17.1, 17.1, 17.1, 17.2, 17.2, 17.2, 17.2, 17.3,
      17.3, 17.3, 17.4, 17.4, 17.4, 17.5, 17.5, 17.5, 17.6, 17.6, 17.6, 17.7,
      17.7, 17.8, 17.8, 17.9, 17.9, 18.0, 18.0, 18.1, 18.1, 18.2, 18.2, 18.3,
      18.3, 18.4, 18.4, 18.5, 18.6, 18.6, 18.7, 18.7, 18.8, 18.8, 18.9, 19.0,
      19.0, 19.1, 19.2, 19.2, 19.3, 19.4, 19.4, 19.5, 19.6, 19.6, 19.7, 19.8,
      19.9, 19.9, 20.0, 20.1, 20.2, 20.2, 20.3, 20.4, 20.5, 20.6, 20.6, 20.7,
      20.8, 20.9, 21.0, 21.1, 21.1, 21.2, 21.3, 21.4, 21.5, 21.6, 21.6, 21.7,
      21.8, 21.9, 22.0, 22.0, 22.1, 22.2, 22.3, 22.4, 22.4, 22.5, 22.6, 22.7,
      22.7, 22.8, 22.9, 22.9, 23.0, 23.1, 23.1, 23.2, 23.3, 23.3, 23.4, 23.5,
      23.5, 23.6, 23.6, 23.7, 23.7, 23.8, 23.8, 23.9, 23.9, 24.0, 24.0, 24.1,
      24.1, 24.1, 24.2, 24.2, 24.3, 24.3, 24.3, 24.4, 24.4, 24.4, 24.4, 24.5,
      24.5, 24.5, 24.6, 24.6, 24.6, 24.6, 24.6, 24.7, 24.7, 24.7, 24.7, 24.8,
      24.8, 24.8, 24.8, 24.8, 24.8, 24.9, 24.9, 24.9, 24.9, 24.9, 24.9, 25.0,
      25.0,
    ],
    sd2: [
      14.7, 16.1, 17.4, 18.0, 18.4, 18.5, 18.6, 18.6, 18.5, 18.4, 18.3, 18.1,
      18.0, 17.8, 17.7, 17.6, 17.5, 17.4, 17.3, 17.2, 17.1, 17.1, 17.0, 17.0,
      18.0, 18.0, 17.9, 17.8, 17.7, 17.7, 17.6, 17.5, 17.4, 17.4, 17.3, 17.3,
      17.2, 17.2, 17.1, 17.1, 17.0, 17.0, 17.0, 16.9, 16.9, 16.9, 16.9, 16.8,
      16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8, 16.8,
      16.8, 16.8, 16.8, 16.8, 16.9, 16.9, 16.9, 16.9, 16.9, 17.0, 17.0, 17.0,
      17.1, 17.1, 17.1, 17.2, 17.2, 17.3, 17.3, 17.3, 17.4, 17.4, 17.5, 17.5,
      17.6, 17.6, 17.7, 17.7, 17.8, 17.8, 17.9, 18.0, 18.0, 18.1, 18.1, 18.2,
      18.3, 18.3, 18.4, 18.4, 18.5, 18.6, 18.6, 18.7, 18.8, 18.8, 18.9, 19.0,
      19.0, 19.1, 19.2, 19.3, 19.3, 19.4, 19.5, 19.5, 19.6, 19.7, 19.8, 19.8,
      19.9, 20.0, 20.1, 20.1, 20.2, 20.3, 20.4, 20.4, 20.5, 20.6, 20.6, 20.7,
      20.8, 20.9, 20.9, 21.0, 21.1, 21.2, 21.2, 21.3, 21.4, 21.5, 21.5, 21.6,
      21.7, 21.7, 21.8, 21.9, 22.0, 22.0, 22.1, 22.2, 22.2, 22.3, 22.4, 22.4,
      22.5, 22.6, 22.6, 22.7, 22.8, 22.8, 22.9, 23.0, 23.0, 23.1, 23.2, 23.2,
      23.3, 23.3, 23.4, 23.5, 23.5, 23.6, 23.6, 23.7, 23.8, 23.8, 23.9, 23.9,
      24.0, 24.0, 24.1, 24.2, 24.2, 24.3, 24.3, 24.4, 24.4, 24.5, 24.5, 24.6,
      24.6, 24.7, 24.7, 24.8, 24.8, 24.9, 24.9, 24.9, 25.0, 25.0, 25.1, 25.1,
      25.2, 25.2, 25.2, 25.3, 25.3, 25.4, 25.4, 25.4, 25.5, 25.5, 25.6, 25.6,
      25.6, 25.7, 25.7, 25.8, 25.8, 25.8, 25.9, 25.9, 25.9, 26.0, 26.0, 26.0,
      26.1,
    ],
    sd3: [
      15.9, 17.3, 18.8, 19.5, 19.8, 20.0, 20.1, 20.1, 20.0, 19.9, 19.7, 19.6,
      19.4, 19.3, 19.1, 19.0, 18.9, 18.7, 18.6, 18.6, 18.5, 18.4, 18.3, 18.3,
      19.6, 19.5, 19.4, 19.3, 19.3, 19.2, 19.1, 19.0, 19.0, 18.9, 18.9, 18.8,
      18.8, 18.7, 18.7, 18.7, 18.7, 18.6, 18.6, 18.6, 18.6, 18.6, 18.6, 18.6,
      18.6, 18.6, 18.6, 18.6, 18.7, 18.7, 18.7, 18.8, 18.8, 18.8, 18.9, 18.9,
      18.9, 19.0, 19.0, 19.1, 19.2, 19.2, 19.3, 19.3, 19.4, 19.5, 19.5, 19.6,
      19.7, 19.8, 19.8, 19.9, 20.0, 20.1, 20.2, 20.2, 20.3, 20.4, 20.5, 20.6,
      20.7, 20.8, 20.9, 21.0, 21.1, 21.2, 21.3, 21.4, 21.5, 21.6, 21.7, 21.8,
      21.9, 22.0, 22.1, 22.2, 22.3, 22.4, 22.5, 22.6, 22.7, 22.8, 22.9, 23.1,
      23.2, 23.3, 23.4, 23.5, 23.6, 23.7, 23.8, 23.9, 24.1, 24.2, 24.3, 24.4,
      24.5, 24.6, 24.7, 24.8, 24.9, 25.0, 25.2, 25.3, 25.4, 25.5, 25.6, 25.7,
      25.8, 25.9, 26.0, 26.1, 26.2, 26.3, 26.4, 26.5, 26.6, 26.7, 26.9, 27.0,
      27.1, 27.2, 27.3, 27.4, 27.5, 27.6, 27.7, 27.8, 27.8, 27.9, 28.0, 28.1,
      28.2, 28.3, 28.4, 28.5, 28.6, 28.7, 28.8, 28.9, 29.0, 29.0, 29.1, 29.2,
      29.3, 29.4, 29.5, 29.6, 29.7, 29.7, 29.8, 29.9, 30.0, 30.1, 30.1, 30.2,
      30.3, 30.4, 30.5, 30.5, 30.6, 30.7, 30.8, 30.9, 30.9, 31.0, 31.1, 31.2,
      31.2, 31.3, 31.4, 31.5, 31.5, 31.6, 31.7, 31.7, 31.8, 31.9, 32.0, 32.0,
      32.1, 32.2, 32.3, 32.3, 32.4, 32.5, 32.6, 32.6, 32.7, 32.8, 32.8, 32.9,
      33.0, 33.1, 33.1, 33.2, 33.3, 33.4, 33.5, 33.5, 33.6, 33.7, 33.8, 33.9,
      33.9,
    ],
  },

  WeightLengthBoys02: {
    sdneg3: [
      11.2, 12.5, 13.9, 14.4, 14.7, 14.8, 14.9, 14.9, 14.8, 14.8, 14.7, 14.6,
      14.5, 14.4, 14.3, 14.2, 14.1, 14.0, 14.0, 13.9, 13.8, 13.8, 13.7, 13.7,
      14.5, 14.5, 14.5, 14.4, 14.4, 14.4, 14.3, 14.3, 14.3, 14.2, 14.2, 14.2,
      14.2, 14.1, 14.1, 14.1, 14.0, 14.0, 14.0, 14.0, 13.9, 13.9, 13.9, 13.9,
      13.9, 13.8, 13.8, 13.8, 13.8, 13.8, 13.8, 13.7, 13.7, 13.7, 13.7, 13.7,
      13.7, 13.7, 13.6, 13.6, 13.6, 13.6, 13.6, 13.6, 13.6, 13.6, 13.6, 13.6,
      13.6, 13.6, 13.5, 13.5, 13.5, 13.5, 13.5, 13.5, 13.5, 13.5, 13.5, 13.5,
      13.5, 13.5, 13.5, 13.5, 13.5, 13.5, 13.5, 13.5, 13.6, 13.6, 13.6, 13.6,
      13.6, 13.6, 13.6, 13.6, 13.6, 13.6, 13.6, 13.6, 13.7, 13.7, 13.7, 13.7,
      13.7, 13.7, 13.7, 13.8, 13.8, 13.8, 13.8, 13.8, 13.9, 13.9, 13.9, 13.9,
      13.9, 14.0, 14.0, 14.0, 14.0, 14.1, 14.1, 14.1, 14.1, 14.2, 14.2, 14.2,
      14.3, 14.3, 14.3, 14.3, 14.4, 14.4, 14.4, 14.5, 14.5, 14.5, 14.6, 14.6,
      14.6, 14.7, 14.7, 14.8, 14.8, 14.8, 14.9, 14.9, 14.9, 15.0, 15.0, 15.1,
      15.1, 15.1, 15.2, 15.2, 15.3, 15.3, 15.4, 15.4, 15.4, 15.5, 15.5, 15.6,
      15.6, 15.7, 15.7, 15.8, 15.8, 15.8, 15.9, 15.9, 16.0, 16.0, 16.1, 16.1,
      16.2, 16.2, 16.3, 16.3, 16.3, 16.4, 16.4, 16.5, 16.5, 16.6, 16.6, 16.7,
      16.7, 16.8, 16.8, 16.9, 16.9, 17.0, 17.0, 17.1, 17.1, 17.1, 17.2, 17.2,
      17.3, 17.3, 17.4, 17.4, 17.5, 17.5, 17.5, 17.6, 17.6, 17.7, 17.7, 17.8,
      17.8, 17.9, 17.9, 17.9, 18.0, 18.0, 18.1, 18.1, 18.1, 18.2, 18.2, 18.3,
      18.3,
    ],
    sdneg2: [
      12.2, 13.6, 15.0, 15.5, 15.8, 15.9, 16.0, 16.0, 15.9, 15.8, 15.7, 15.6,
      15.5, 15.4, 15.3, 15.2, 15.1, 14.9, 14.9, 14.9, 14.8, 14.7, 14.7, 14.6,
      15.3, 15.3, 15.2, 15.2, 15.2, 15.1, 15.1, 15.1, 15.0, 15.0, 15.0, 14.9,
      14.9, 14.9, 14.8, 14.8, 14.8, 14.7, 14.7, 14.7, 14.7, 14.6, 14.6, 14.6,
      14.6, 14.5, 14.5, 14.5, 14.5, 14.5, 14.4, 14.4, 14.4, 14.4, 14.4, 14.4,
      14.3, 14.3, 14.3, 14.3, 14.3, 14.3, 14.3, 14.3, 14.3, 14.2, 14.2, 14.2,
      14.2, 14.2, 14.2, 14.2, 14.2, 14.2, 14.2, 14.2, 14.2, 14.2, 14.2, 14.2,
      14.2, 14.2, 14.3, 14.3, 14.3, 14.3, 14.3, 14.3, 14.3, 14.3, 14.3, 14.3,
      14.4, 14.4, 14.4, 14.4, 14.4, 14.4, 14.5, 14.5, 14.5, 14.5, 14.5, 14.6,
      14.6, 14.6, 14.6, 14.6, 14.7, 14.7, 14.7, 14.7, 14.8, 14.8, 14.8, 14.9,
      14.9, 14.9, 14.9, 15.0, 15.0, 15.0, 15.1, 15.1, 15.1, 15.2, 15.2, 15.2,
      15.3, 15.3, 15.4, 15.4, 15.4, 15.5, 15.5, 15.5, 15.6, 15.6, 15.7, 15.7,
      15.8, 15.8, 15.8, 15.9, 15.9, 16.0, 16.0, 16.1, 16.1, 16.1, 16.2, 16.2,
      16.3, 16.3, 16.4, 16.4, 16.5, 16.5, 16.6, 16.6, 16.7, 16.7, 16.8, 16.8,
      16.9, 16.9, 17.0, 17.0, 17.1, 17.1, 17.2, 17.2, 17.3, 17.3, 17.4, 17.4,
      17.5, 17.5, 17.6, 17.6, 17.7, 17.7, 17.8, 17.8, 17.9, 17.9, 18.0, 18.0,
      18.1, 18.1, 18.2, 18.2, 18.3, 18.3, 18.4, 18.4, 18.5, 18.5, 18.6, 18.6,
      18.7, 18.7, 18.8, 18.8, 18.9, 18.9, 19.0, 19.0, 19.1, 19.1, 19.2, 19.2,
      19.3, 19.3, 19.4, 19.4, 19.5, 19.5, 19.5, 19.6, 19.6, 19.7, 19.7, 19.8,
      19.8,
    ],
    sdneg1: [
      12.2, 13.6, 15.0, 15.5, 15.8, 15.9, 16.0, 16.0, 15.9, 15.8, 15.7, 15.6,
      15.5, 15.4, 15.3, 15.2, 15.1, 14.9, 14.9, 14.9, 14.8, 14.7, 14.7, 14.6,
      14.6, 14.8, 14.8, 14.7, 14.7, 14.7, 14.6, 14.6, 14.6, 14.5, 14.5, 14.5,
      14.5, 14.4, 14.4, 14.3, 14.3, 14.3, 14.3, 14.2, 14.2, 14.2, 14.2, 14.2,
      14.1, 14.1, 14.1, 14.1, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0, 14.0,
      14.0, 14.1, 14.1, 14.1, 14.1, 14.1, 14.1, 14.1, 14.1, 14.1, 14.1, 14.1,
      14.1, 14.1, 14.1, 14.1, 14.1, 14.1, 14.1, 14.1, 14.2, 14.2, 14.2, 14.2,
      14.2, 14.2, 14.2, 14.3, 14.3, 14.3, 14.3, 14.3, 14.3, 14.3, 14.4, 14.4,
      14.4, 14.4, 14.4, 14.5, 14.5, 14.5, 14.5, 14.5, 14.5, 14.6, 14.6, 14.6,
      14.6, 14.6, 14.6, 14.7, 14.7, 14.7, 14.7, 14.8, 14.8, 14.8, 14.8, 14.9,
      14.9, 14.9, 15.0, 15.0, 15.0, 15.1, 15.1, 15.1, 15.2, 15.2, 15.2, 15.3,
      15.3, 15.3, 15.4, 15.4, 15.5, 15.5, 15.5, 15.6, 15.6, 15.7, 15.7, 15.7,
      15.8, 15.8, 15.9, 15.9, 16.0, 16.0, 16.1, 16.1, 16.2, 16.2, 16.3, 16.3,
      16.4, 16.4, 16.5, 16.5, 16.6, 16.6, 16.7, 16.7, 16.8, 16.8, 16.9, 17.0,
      17.0, 17.1, 17.1, 17.2, 17.2, 17.3, 17.3, 17.4, 17.4, 17.5, 17.5, 17.6,
      17.6, 17.7, 17.7, 17.8, 17.8, 17.9, 17.9, 18.0, 18.0, 18.1, 18.1, 18.2,
      18.2, 18.3, 18.3, 18.4, 18.4, 18.5, 18.5, 18.6, 18.6, 18.7, 18.7, 18.7,
      18.8, 18.8, 18.9, 18.9, 18.9, 19.0, 19.0, 19.1, 19.1, 19.1, 19.2, 19.2,
      19.2, 19.3, 19.3, 19.3, 19.4, 19.4, 19.4, 19.5, 19.5, 19.5, 19.6, 19.6,
      19.6,
    ],
    median: [
      13.4, 14.9, 16.3, 16.9, 17.2, 17.3, 17.3, 17.3, 17.3, 17.2, 17.0, 16.9,
      16.8, 16.7, 16.6, 16.4, 16.3, 16.1, 16.1, 16.1, 16.0, 15.9, 15.8, 15.8,
      16.6, 16.5, 16.5, 16.4, 16.4, 16.3, 16.3, 16.2, 16.2, 16.2, 16.1, 16.1,
      16.0, 16.0, 16.0, 15.9, 15.9, 15.9, 15.8, 15.8, 15.8, 15.7, 15.7, 15.7,
      15.7, 15.6, 15.6, 15.6, 15.6, 15.5, 15.5, 15.5, 15.5, 15.5, 15.5, 15.4,
      15.4, 15.4, 15.4, 15.4, 15.4, 15.4, 15.4, 15.4, 15.4, 15.4, 15.4, 15.4,
      15.4, 15.4, 15.4, 15.4, 15.4, 15.4, 15.4, 15.4, 15.4, 15.5, 15.5, 15.5,
      15.5, 15.5, 15.5, 15.5, 15.6, 15.6, 15.6, 15.6, 15.7, 15.7, 15.7, 15.7,
      15.8, 15.8, 15.8, 15.8, 15.9, 15.9, 15.9, 16.0, 16.0, 16.0, 16.1, 16.1,
      16.1, 16.2, 16.2, 16.2, 16.3, 16.3, 16.4, 16.4, 16.4, 16.5, 16.5, 16.6,
      16.6, 16.6, 16.7, 16.7, 16.8, 16.8, 16.9, 16.9, 17.0, 17.0, 17.1, 17.1,
      17.2, 17.2, 17.3, 17.3, 17.3, 17.4, 17.5, 17.5, 17.6, 17.6, 17.7, 17.7,
      17.8, 17.8, 17.9, 17.9, 18.0, 18.0, 18.1, 18.1, 18.2, 18.2, 18.3, 18.4,
      18.4, 18.5, 18.5, 18.6, 18.6, 18.7, 18.8, 18.8, 18.9, 18.9, 19.0, 19.0,
      19.1, 19.2, 19.2, 19.3, 19.3, 19.4, 19.4, 19.5, 19.6, 19.6, 19.7, 19.7,
      19.8, 19.9, 19.9, 20.0, 20.0, 20.1, 20.2, 20.2, 20.3, 20.3, 20.4, 20.4,
      20.5, 20.6, 20.6, 20.7, 20.7, 20.8, 20.8, 20.9, 21.0, 21.0, 21.1, 21.1,
      21.2, 21.2, 21.3, 21.4, 21.4, 21.5, 21.5, 21.6, 21.6, 21.7, 21.7, 21.8,
      21.8, 21.9, 21.9, 22.0, 22.1, 22.1, 22.2, 22.2, 22.3, 22.3, 22.4, 22.4,
      22.5,
    ],
    sd1: [
      14.8, 16.3, 17.8, 18.4, 18.7, 18.8, 18.8, 18.8, 18.7, 18.6, 18.5, 18.4,
      18.2, 18.1, 18.0, 17.8, 17.7, 17.6, 17.5, 17.4, 17.3, 17.2, 17.2, 17.1,
      17.0, 17.3, 17.3, 17.2, 17.2, 17.1, 17.1, 17.1, 17.0, 17.0, 17.0, 16.9,
      16.9, 16.9, 16.8, 16.8, 16.8, 16.8, 16.8, 16.7, 16.7, 16.7, 16.7, 16.7,
      16.7, 16.7, 16.7, 16.7, 16.6, 16.6, 16.6, 16.6, 16.6, 16.6, 16.6, 16.6,
      16.6, 16.6, 16.6, 16.7, 16.7, 16.7, 16.7, 16.7, 16.7, 16.7, 16.7, 16.7,
      16.8, 16.8, 16.8, 16.8, 16.8, 16.9, 16.9, 16.9, 16.9, 17.0, 17.0, 17.0,
      17.0, 17.1, 17.1, 17.1, 17.2, 17.2, 17.2, 17.3, 17.3, 17.3, 17.4, 17.4,
      17.4, 17.5, 17.5, 17.5, 17.6, 17.7, 17.7, 17.7, 17.7, 17.8, 17.8, 17.9,
      17.9, 18.0, 18.0, 18.0, 18.1, 18.1, 18.1, 18.2, 18.3, 18.3, 18.4, 18.4,
      18.5, 18.5, 18.6, 18.6, 18.7, 18.8, 18.8, 18.9, 18.9, 19.0, 19.0, 19.1,
      19.2, 19.2, 19.3, 19.3, 19.4, 19.5, 19.5, 19.6, 19.6, 19.7, 19.7, 19.9,
      19.9, 20.0, 20.1, 20.2, 20.2, 20.3, 20.4, 20.4, 20.5, 20.6, 20.7, 20.8,
      20.8, 20.9, 21.0, 21.1, 21.1, 21.2, 21.3, 21.4, 21.5, 21.5, 21.6, 21.7,
      21.8, 21.8, 21.9, 22.0, 22.1, 22.2, 22.2, 22.3, 22.4, 22.5, 22.5, 22.6,
      22.7, 22.8, 22.8, 22.9, 23.0, 23.0, 23.1, 23.2, 23.3, 23.3, 23.4, 23.5,
      23.5, 23.6, 23.7, 23.7, 23.8, 23.8, 23.9, 24.0, 24.0, 24.1, 24.2, 24.2,
      24.3, 24.3, 24.4, 24.4, 24.5, 24.5, 24.6, 24.7, 24.7, 24.8, 24.8, 24.9,
      24.9, 25.0, 25.0, 25.1, 25.1, 25.1, 25.2, 25.2, 25.3, 25.3, 25.4, 25.4,
    ],
    sd2: [
      14.9, 16.4, 17.9, 18.5, 18.8, 18.9, 18.9, 18.9, 18.8, 18.7, 18.6, 18.5,
      18.3, 18.2, 18.1, 17.9, 17.8, 17.7, 17.6, 17.5, 17.4, 17.3, 17.3, 17.2,
      18.2, 18.1, 18.0, 18.0, 17.9, 17.8, 17.7, 17.7, 17.6, 17.5, 17.5, 17.4,
      17.4, 17.3, 17.3, 17.2, 17.2, 17.2, 17.1, 17.1, 17.0, 17.0, 17.0, 17.0,
      16.9, 16.9, 16.9, 16.9, 16.9, 16.9, 16.9, 16.8, 16.8, 16.8, 16.8, 16.8,
      16.8, 16.8, 16.8, 16.9, 16.9, 16.9, 16.9, 16.9, 16.9, 16.9, 16.9, 17.0,
      17.0, 17.0, 17.0, 17.1, 17.1, 17.1, 17.2, 17.2, 17.2, 17.3, 17.3, 17.3,
      17.4, 17.4, 17.4, 17.5, 17.5, 17.6, 17.6, 17.7, 17.7, 17.8, 17.8, 17.9,
      17.9, 18.0, 18.0, 18.1, 18.1, 18.2, 18.2, 18.3, 18.3, 18.4, 18.5, 18.5,
      18.6, 18.6, 18.7, 18.8, 18.8, 18.9, 18.9, 19.0, 19.1, 19.1, 19.2, 19.3,
      19.3, 19.4, 19.5, 19.5, 19.6, 19.7, 19.7, 19.8, 19.9, 19.9, 20.0, 20.1,
      20.1, 20.2, 20.3, 20.3, 20.4, 20.5, 20.5, 20.6, 20.7, 20.7, 20.8, 20.9,
      21.0, 21.0, 21.1, 21.2, 21.2, 21.3, 21.4, 21.4, 21.5, 21.6, 21.6, 21.7,
      21.8, 21.9, 21.9, 22.0, 22.1, 22.1, 22.2, 22.3, 22.3, 22.4, 22.5, 22.5,
      22.6, 22.7, 22.7, 22.8, 22.9, 22.9, 23.0, 23.1, 23.1, 23.2, 23.3, 23.3,
      23.4, 23.5, 23.5, 23.6, 23.6, 23.7, 23.8, 23.8, 23.9, 24.0, 24.0, 24.1,
      24.1, 24.2, 24.3, 24.3, 24.4, 24.5, 24.5, 24.6, 24.6, 24.7, 24.8, 24.8,
      24.9, 24.9, 25.0, 25.1, 25.1, 25.2, 25.2, 25.3, 25.4, 25.4, 25.5, 25.5,
      25.6, 25.7, 25.7, 25.8, 25.8, 25.9, 25.9, 26.0, 26.1, 26.1, 26.2, 26.2,
      26.3,
    ],
    sd3: [
      16.1, 17.6, 19.2, 19.8, 20.1, 20.3, 20.3, 20.3, 20.2, 20.1, 19.9, 19.8,
      19.6, 19.5, 19.3, 19.2, 19.1, 18.9, 18.8, 18.7, 18.6, 18.5, 18.5, 18.4,
      19.9, 19.8, 19.7, 19.5, 19.4, 19.3, 19.2, 19.1, 19.0, 18.9, 18.8, 18.8,
      18.7, 18.6, 18.6, 18.5, 18.5, 18.4, 18.4, 18.3, 18.3, 18.3, 18.3, 18.2,
      18.2, 18.2, 18.2, 18.2, 18.2, 18.2, 18.3, 18.3, 18.3, 18.3, 18.3, 18.4,
      18.4, 18.4, 18.5, 18.5, 18.6, 18.6, 18.7, 18.7, 18.8, 18.8, 18.9, 19.0,
      19.0, 19.1, 19.2, 19.3, 19.3, 19.4, 19.5, 19.6, 19.6, 19.7, 19.8, 19.9,
      20.0, 20.1, 20.2, 20.3, 20.4, 20.5, 20.5, 20.6, 20.7, 20.8, 20.9, 21.0,
      21.1, 21.2, 21.3, 21.4, 21.5, 21.6, 21.7, 21.9, 22.0, 22.1, 22.2, 22.3,
      22.4, 22.5, 22.6, 22.7, 22.8, 22.9, 23.0, 23.1, 23.2, 23.3, 23.4, 23.5,
      23.6, 23.7, 23.8, 23.9, 24.0, 24.1, 24.2, 24.3, 24.4, 24.5, 24.6, 24.7,
      24.8, 24.9, 25.0, 25.1, 25.2, 25.3, 25.4, 25.5, 25.6, 25.7, 25.8, 25.9,
      25.9, 26.0, 26.1, 26.2, 26.3, 26.4, 26.5, 26.5, 26.6, 26.7, 26.8, 26.9,
      26.9, 27.0, 27.1, 27.2, 27.2, 27.3, 27.4, 27.5, 27.5, 27.6, 27.7, 27.7,
      27.8, 27.9, 28.0, 28.0, 28.1, 28.1, 28.2, 28.3, 28.3, 28.4, 28.5, 28.5,
      28.6, 28.6, 28.7, 28.8, 28.8, 28.9, 28.9, 29.0, 29.0, 29.1, 29.1, 29.2,
      29.3, 29.3, 29.4, 29.4, 29.5, 29.5, 29.6, 29.6, 29.7, 29.7, 29.8, 29.8,
      29.9, 29.9, 30.0, 30.0, 30.1, 30.2, 30.2, 30.3, 30.3, 30.4, 30.4, 30.5,
      30.6, 30.6, 30.7, 30.7, 30.8, 30.9, 30.9, 31.0, 31.1, 31.1, 31.2, 31.3,
      31.3,
    ],
  },

  HeadCircunferenceGirls: {
    sdneg3: [
      30.3, 33.0, 34.6, 35.8, 36.8, 37.6, 38.3, 38.9, 39.4, 39.8, 40.2, 40.5,
      40.8, 41.1, 41.3, 41.5, 41.7, 41.9, 42.1, 42.3, 42.4, 42.6, 42.7, 42.9,
      43.0, 43.1, 43.3, 43.4, 43.5, 43.6, 43.7, 43.8, 43.9, 44.0, 44.1, 44.2,
      44.3, 44.4, 44.4, 44.5, 44.6, 44.6, 44.7, 44.8, 44.8, 44.9, 45.0, 45.0,
      45.1, 45.1, 45.2, 45.2, 45.3, 45.3, 45.4, 45.4, 45.5, 45.5, 45.6, 45.6,
      45.7,
    ],
    sdneg2: [
      31.5, 34.2, 35.8, 37.1, 38.1, 38.9, 39.6, 40.2, 40.7, 41.2, 41.5, 41.9,
      42.2, 42.4, 42.7, 42.9, 43.1, 43.3, 43.5, 43.6, 43.8, 44.0, 44.1, 44.3,
      44.4, 44.5, 44.7, 44.8, 44.9, 45.0, 45.1, 45.2, 45.3, 45.4, 45.5, 45.6,
      45.7, 45.8, 45.8, 45.9, 46.0, 46.1, 46.1, 46.2, 46.3, 46.3, 46.4, 46.4,
      46.5, 46.5, 46.6, 46.7, 46.7, 46.8, 46.8, 46.9, 46.9, 46.9, 47.0, 47.0,
      47.1,
    ],
    sdneg1: [
      32.7, 35.4, 37.0, 38.3, 39.3, 40.2, 40.9, 41.5, 42.0, 42.5, 42.9, 43.2,
      43.5, 43.8, 44.1, 44.3, 44.5, 44.7, 44.9, 45.0, 45.2, 45.3, 45.5, 45.6,
      45.8, 45.9, 46.1, 46.2, 46.3, 46.4, 46.5, 46.6, 46.7, 46.8, 46.9, 47.0,
      47.1, 47.2, 47.3, 47.3, 47.4, 47.5, 47.5, 47.6, 47.7, 47.7, 47.8, 47.9,
      47.9, 48.0, 48.0, 48.1, 48.1, 48.2, 48.2, 48.3, 48.3, 48.4, 48.4, 48.5,
      48.5,
    ],
    median: [
      33.9, 36.5, 38.3, 39.5, 40.6, 41.5, 42.2, 42.8, 43.4, 43.8, 44.2, 44.6,
      44.9, 45.2, 45.4, 45.7, 45.9, 46.1, 46.2, 46.4, 46.6, 46.7, 46.9, 47.0,
      47.2, 47.3, 47.5, 47.6, 47.7, 47.8, 47.9, 48.0, 48.1, 48.2, 48.3, 48.4,
      48.5, 48.6, 48.7, 48.7, 48.8, 48.9, 49.0, 49.0, 49.1, 49.2, 49.2, 49.3,
      49.3, 49.4, 49.4, 49.5, 49.5, 49.6, 49.6, 49.7, 49.7, 49.8, 49.8, 49.9,
      49.9,
    ],
    sd1: [
      35.1, 37.7, 39.5, 40.8, 41.8, 42.7, 43.5, 44.1, 44.7, 45.2, 45.6, 45.9,
      46.3, 46.5, 46.8, 47.0, 47.2, 47.4, 47.6, 47.8, 48.0, 48.1, 48.3, 48.4,
      48.6, 48.7, 48.9, 49.0, 49.1, 49.2, 49.3, 49.4, 49.6, 49.7, 49.7, 49.8,
      49.9, 50.0, 50.1, 50.2, 50.2, 50.3, 50.4, 50.4, 50.5, 50.6, 50.6, 50.7,
      50.8, 50.8, 50.9, 50.9, 51.0, 51.0, 51.1, 51.1, 51.2, 51.2, 51.3, 51.3,
      51.3,
    ],
    sd2: [
      36.2, 38.9, 40.7, 42.0, 43.1, 44.0, 44.8, 45.5, 46.0, 46.5, 46.9, 47.3,
      47.6, 47.9, 48.2, 48.4, 48.6, 48.8, 49.0, 49.2, 49.4, 49.5, 49.7, 49.8,
      50.0, 50.1, 50.3, 50.4, 50.5, 50.6, 50.7, 50.9, 51.0, 51.1, 51.2, 51.2,
      51.3, 51.4, 51.5, 51.6, 51.7, 51.7, 51.8, 51.9, 51.9, 52.0, 52.1, 52.1,
      52.2, 52.2, 52.3, 52.3, 52.4, 52.4, 52.5, 52.5, 52.6, 52.6, 52.7, 52.7,
      52.8,
    ],
    sd3: [
      37.4, 40.1, 41.9, 43.3, 44.4, 45.3, 46.1, 46.8, 47.4, 47.8, 48.3, 48.6,
      49.0, 49.3, 49.5, 49.8, 50.0, 50.2, 50.4, 50.6, 50.7, 50.9, 51.1, 51.2,
      51.4, 51.5, 51.7, 51.8, 51.9, 52.0, 52.2, 52.3, 52.4, 52.5, 52.6, 52.7,
      52.7, 52.8, 52.9, 53.0, 53.1, 53.1, 53.2, 53.3, 53.3, 53.4, 53.5, 53.5,
      53.6, 53.6, 53.7, 53.8, 53.8, 53.9, 53.9, 54.0, 54.0, 54.1, 54.1, 54.1,
      54.2,
    ],
  },

  HeadCircunferenceBoys: {
    sdneg3: [
      30.7, 33.8, 35.6, 37.0, 38.0, 38.9, 39.7, 40.3, 40.8, 41.2, 41.6, 41.9,
      42.2, 42.5, 42.7, 42.9, 43.1, 43.2, 43.4, 43.5, 43.7, 43.8, 43.9, 44.1,
      44.2, 44.3, 44.4, 44.5, 44.6, 44.7, 44.8, 44.8, 44.9, 45.0, 45.1, 45.1,
      45.2, 45.3, 45.3, 45.4, 45.4, 45.5, 45.5, 45.6, 45.6, 45.7, 45.7, 45.8,
      45.8, 45.9, 45.9, 45.9, 46.0, 46.0, 46.1, 46.1, 46.1, 46.2, 46.2, 46.2,
      46.3,
    ],
    sdneg2: [
      31.9, 34.9, 36.8, 38.1, 39.2, 40.1, 40.9, 41.5, 42.0, 42.5, 42.9, 43.2,
      43.5, 43.8, 44.0, 44.2, 44.4, 44.6, 44.7, 44.9, 45.0, 45.2, 45.3, 45.4,
      45.5, 45.6, 45.8, 45.9, 46.0, 46.1, 46.1, 46.2, 46.3, 46.4, 46.5, 46.6,
      46.6, 46.7, 46.8, 46.8, 46.9, 46.9, 47.0, 47.0, 47.1, 47.1, 47.2, 47.2,
      47.3, 47.3, 47.4, 47.4, 47.5, 47.5, 47.5, 47.6, 47.6, 47.6, 47.7, 47.7,
      47.7,
    ],
    sdneg1: [
      33.2, 36.1, 38.0, 39.3, 40.4, 41.4, 42.1, 42.7, 43.3, 43.7, 44.1, 44.5,
      44.8, 45.0, 45.3, 45.5, 45.7, 45.9, 46.0, 46.2, 46.4, 46.5, 46.6, 46.8,
      46.9, 47.0, 47.1, 47.2, 47.3, 47.4, 47.5, 47.6, 47.7, 47.8, 47.9, 48.0,
      48.0, 48.1, 48.2, 48.2, 48.3, 48.4, 48.4, 48.5, 48.5, 48.6, 48.7, 48.7,
      48.7, 48.8, 48.8, 48.9, 48.9, 49.0, 49.0, 49.1, 49.1, 49.1, 49.2, 49.2,
      49.2,
    ],
    median: [
      34.5, 37.3, 39.1, 40.5, 41.6, 42.6, 43.3, 44.0, 44.5, 45.0, 45.4, 45.8,
      46.1, 46.3, 46.6, 46.8, 47.0, 47.2, 47.4, 47.5, 47.7, 47.8, 48.0, 48.1,
      48.3, 48.4, 48.5, 48.6, 48.7, 48.8, 48.9, 49.0, 49.1, 49.2, 49.3, 49.4,
      49.5, 49.5, 49.6, 49.7, 49.7, 49.8, 49.9, 49.9, 50.0, 50.1, 50.1, 50.2,
      50.2, 50.3, 50.3, 50.4, 50.4, 50.4, 50.5, 50.5, 50.6, 50.6, 50.7, 50.7,
      50.7,
    ],
    sd1: [
      35.7, 38.4, 40.3, 41.7, 42.8, 43.8, 44.6, 45.2, 45.8, 46.3, 46.7, 47.0,
      47.4, 47.6, 47.9, 48.1, 48.3, 48.5, 48.7, 48.9, 49.0, 49.2, 49.3, 49.5,
      49.6, 49.7, 49.9, 50.0, 50.1, 50.2, 50.3, 50.4, 50.5, 50.6, 50.7, 50.8,
      50.9, 51.0, 51.0, 51.1, 51.2, 51.3, 51.3, 51.4, 51.4, 51.5, 51.6, 51.6,
      51.7, 51.7, 51.8, 51.8, 51.9, 51.9, 52.0, 52.0, 52.1, 52.1, 52.1, 52.2,
      52.2,
    ],
    sd2: [
      37.0, 39.6, 41.5, 42.9, 44.0, 45.0, 45.8, 46.4, 47.0, 47.5, 47.9, 48.3,
      48.6, 48.9, 49.2, 49.4, 49.6, 49.8, 50.0, 50.2, 50.4, 50.5, 50.7, 50.8,
      51.0, 51.1, 51.2, 51.4, 51.5, 51.6, 51.7, 51.8, 51.9, 52.0, 52.1, 52.2,
      52.3, 52.4, 52.5, 52.5, 52.6, 52.7, 52.8, 52.8, 52.9, 53.0, 53.0, 53.1,
      53.1, 53.2, 53.2, 53.3, 53.4, 53.4, 53.5, 53.5, 53.5, 53.6, 53.6, 53.7,
      53.7,
    ],
    sd3: [
      38.3, 40.8, 42.6, 44.1, 45.2, 46.2, 47.0, 47.7, 48.3, 48.8, 49.2, 49.6,
      49.9, 50.2, 50.5, 50.7, 51.0, 51.2, 51.4, 51.5, 51.7, 51.9, 52.0, 52.2,
      52.3, 52.5, 52.6, 52.7, 52.9, 53.0, 53.1, 53.2, 53.3, 53.4, 53.5, 53.6,
      53.7, 53.8, 53.9, 54.0, 54.1, 54.1, 54.2, 54.3, 54.3, 54.4, 54.5, 54.5,
      54.6, 54.7, 54.7, 54.8, 54.8, 54.9, 54.9, 55.0, 55.0, 55.1, 55.1, 55.2,
      55.2,
    ],
  },
};

export const Categories = {
  age_complete: [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "60",
  ],
  age_0_2: [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "100",
    "101",
    "102",
    "103",
    "104",
  ],
  age_2_5: [
    "25",
    "26",
    "27",
    "28",
    "29",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "60",
  ],
};
